import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";

import "./operation.css";
import TestimonialSlider from "components/Sections/testimonal-comp/TestimonialSlider";
import Tabs from "components/Sections/teraservicetabs/tabs";
import CardList from "components/Sections/servicesolutions/oursolutions";
import firsttabimg from "./images/firsttabimg.webp";
import secondtabimg from "./images/secondtabimg.webp";
import thirdtabimg from "./images/thirdtabimg.webp";
import fourthtabimg from "./images/fourthimg.webp";
import backgroundfooter from "./images/backgrounfooter.webp";
import JoinNetwork from "components/Sections/mobileappdownload/mobileappdownload";
import qrtera from "./images/mobqr.png";
import Accordion from "components/Sections/teraaccordian/accordian";

import facility from "./images/Facility.png";
import gas from "./images/oxygen-tank.png";
import transplant from "./images/transplant-unit.png";
import isa from "./images/Industry-specific-architectires.png";
import leaddoor from "./images/Lead-doors.png";
import radiation from "./images/dosimeter.png";
import stp from "./images/stp.png";
import insurance from "./images/health-insurance.png";
import accredition from "./images/accreditation.png";
import branding from "./images/branding.png";
import furniture from "./images/furniture.png";
import hospitality from "./images/hospitality.png";
import asp from "./images/asp.png";
import surgical from "./images/surgical.png";
import modular from "./images/modular.png";
import firegas from "./images/firegas.png";
import gaspipeline from "./images/gaspipeline.png";

import twoone from "./images/21.png";
import twotwo from "./images/22.png";
import twothree from "./images/23.png";
import twofour from "./images/24.png";
import twofive from "./images/25.png";
import twosix from "./images/26.png";
import twoseven from "./images/27.png";

import threeone from "./images/31.png";
import threetwo from "./images/32.png";
import threethree from "./images/33.png";
import threefour from "./images/34.png";
import threefive from "./images/35.png";

import fourone from "./images/41.png";
import fourtwo from "./images/42.png";

import fiveone from "./images/51.png";

import sixone from "./images/61.png";
import sixtwo from "./images/62.png";
import sixthree from "./images/63.png";

import seven from "./images/7.png";
import sevenone from "./images/71.png";

import eight from "./images/ithard.png";
import eightone from "./images/82.png";
import eighttwo from "./images/83.png";
import eightthree from "./images/84.png";

import nine from "./images/9.png";
import nineone from "./images/91.png";
import ninetwo from "./images/92.png";
import ninethree from "./images/93.png";

import ten from "./images/10.png";
import tenone from "./images/101.png";

import n1 from "./images/n1.png"
import n2 from "./images/n2.png"
import n3 from "./images/n3.png"
import n4 from "./images/n4.png"
import n5 from "./images/n5.png"

import z1 from "./images/z1.png"
import z2 from "./images/z2.png"
import z3 from "./images/z3.png"
import z4 from "./images/z4.png"
import z5 from "./images/z5.png"


import y1 from "./images/q1.png"
import y2 from "./images/q2.png"
import y3 from "./images/q3.png"

import o1 from "./images/o1.png"
import o2 from "./images/o2.png"
import o3 from "./images/o3.png"
import o4 from "./images/o4.png"
import o5 from "./images/o5.png"
import o6 from "./images/o6.png"


import qrterapartner from "./images/terapartner.png";
import qrteraclients from "./images/teraclients.png";
import qeteraclinicians from "./images/teraclinician.png";
import Tab from "components/Sections/pricingpagtab/pricingtab";
import { Link } from "react-router-dom"; // Import the Link component
import persondefault from "./images/person-default.png"
import logodefault from "./images/logo-default.png"
function staffinghr() {
  const tabData = [
    {
      tabName: "Tab a",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="73"
          height="63"
          viewBox="0 0 73 63"
          fill="none"
        >
          <g clip-path="url(#clip0_251_4463)">
            <path
              d="M18.0693 36.1416H10.9177C9.6053 36.1416 8.54016 37.1876 8.54016 38.4763V45.5178V53.4185V60.46C8.54016 61.7488 9.6053 62.7947 10.9177 62.7947H18.0693H26.134H33.2856C34.598 62.7947 35.6631 61.7488 35.6631 60.46V53.4185C37.8885 53.4185 39.6954 51.6441 39.6954 49.4588C39.6954 47.2735 37.8885 45.4991 35.6631 45.4991V38.4763C35.6631 37.1876 34.598 36.1416 33.2856 36.1416H26.1149C26.0769 38.2895 24.289 40.0266 22.0826 40.0266C19.8953 40.0266 18.1074 38.2895 18.0693 36.1416Z"
              fill="#F29F05"
            />
            <path
              d="M56.6425 30.893L63.6229 32.4619C64.8973 32.7421 66.1907 31.9576 66.476 30.7062L68.0737 23.8514C70.242 24.3371 72.4103 23.0109 72.9049 20.8817C73.3994 18.7524 72.0489 16.6232 69.8806 16.1375L71.4783 9.28281C71.7636 8.0314 70.9648 6.76132 69.6904 6.48115L62.71 4.91222C62.71 4.89354 62.729 4.87486 62.729 4.83751C63.2235 2.70825 61.8731 0.578985 59.7048 0.0933638C57.5364 -0.392257 55.3681 0.933862 54.8736 3.06312C54.8736 3.0818 54.8546 3.10048 54.8546 3.13783L47.8741 1.5689C46.5998 1.28874 45.3064 2.0732 45.0211 3.32461L43.4234 10.1793C45.5917 10.665 46.9421 12.7942 46.4476 14.9235C45.9531 17.0527 43.7847 18.3789 41.6164 17.8932L40.0187 24.748C39.7334 25.9994 40.5323 27.2695 41.8066 27.5496L48.7871 29.1186C49.2816 26.9893 51.4499 25.6632 53.6182 26.1488C55.7866 26.6344 57.137 28.7637 56.6425 30.893Z"
              fill="#2A46AE"
            />
            <path
              d="M5.51593 26.2796L8.04563 32.8728C8.50212 34.0868 9.8906 34.6845 11.1079 34.2363L17.8031 31.7521C18.5829 33.788 20.9034 34.834 22.9956 34.0682C25.0688 33.3024 26.134 31.0237 25.3541 28.9691L32.0493 26.485C33.2856 26.0367 33.8943 24.6733 33.4378 23.4779L30.9081 16.8847C30.9271 16.8847 30.9461 16.866 30.9841 16.866C33.0574 16.1002 34.1225 13.8215 33.3427 11.767C32.5628 9.73108 30.2423 8.68513 28.1501 9.45091C28.1311 9.45091 28.1121 9.46959 28.074 9.46959L25.5443 2.87635C25.0878 1.6623 23.6994 1.06461 22.4821 1.51288L15.7869 4.01569C16.5667 6.05157 15.5206 8.34893 13.4284 9.11472C11.3361 9.8805 9.01567 8.85323 8.23584 6.79868L1.54068 9.28281C0.304362 9.73108 -0.304289 11.0946 0.152199 12.2899L2.6819 18.8645C4.75512 18.0987 7.09462 19.126 7.87445 21.1805C8.65428 23.2351 7.58915 25.5138 5.51593 26.2796Z"
              fill="#1188A8"
            />
            <path
              d="M38.8395 53.6239V60.6654C38.8395 61.9542 39.9046 63.0001 41.217 63.0001H48.3877H56.4523H63.623C64.9354 63.0001 66.0005 61.9542 66.0005 60.6654V53.6239V45.7046V38.663C66.0005 37.3743 64.9354 36.3283 63.623 36.3283H56.4523C56.4523 34.143 54.6454 32.3687 52.42 32.3687C50.1946 32.3687 48.3877 34.143 48.3877 36.3283H41.217C39.9046 36.3283 38.8395 37.3743 38.8395 38.663V45.7046C41.0268 45.7419 42.7957 47.4976 42.7957 49.6642C42.8147 51.8309 41.0458 53.5866 38.8395 53.6239Z"
              fill="#6EB1B0"
            />
          </g>
          <defs>
            <clipPath id="clip0_251_4463">
              <rect width="73" height="63" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      mainHeading: "Infrastructure Puzzles",
      subHeading:
        "Making sense of the complexities in setting up and maintaining crucial medical structures.",
      imageSrc: firsttabimg,
    },
    {
      tabName: "Tab b",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="66"
          viewBox="0 0 50 66"
          fill="none"
        >
          <path
            d="M27.3677 0H22.3852L8.0155 58.1288H41.7374L27.3677 0Z"
            fill="#F29F05"
          />
          <path
            d="M49.8247 57.9126H0V66.0001H49.8247V57.9126Z"
            fill="#FFBB61"
          />
          <path
            d="M38.9212 46.7203L36.3217 36.1055H13.4312L10.8317 46.7203H38.9212Z"
            fill="#D9E3E9"
          />
          <path
            d="M31.7004 17.4761L29.5341 8.73877H20.219L18.0527 17.4761H31.7004Z"
            fill="#D9E3E9"
          />
        </svg>
      ),
      mainHeading: "Regulatory Roadblocks",
      subHeading:
        "Navigating the accreditation maze and compliance hurdles for smooth medical operations. ",
      imageSrc: secondtabimg,
    },
    {
      tabName: "Tab c",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="66"
          height="70"
          viewBox="0 0 66 70"
          fill="none"
        >
          <path
            d="M32.9975 69.7374C27.1639 66.3566 22.3469 62.568 18.3692 58.5607C12.5769 52.7271 8.56964 46.4384 5.80946 40.2915C-2.37652 22.046 0.484142 5.07117 0.484142 5.07117C0.484142 5.07117 4.00086 8.45785 15.6444 6.95069C27.8082 5.38442 32.9975 0 32.9975 0C32.9975 0 38.1869 5.38442 50.3565 6.95069C62.0001 8.45785 65.5168 5.07117 65.5168 5.07117C65.5168 5.07117 72.5443 46.8049 32.9975 69.7374Z"
            fill="#00C72E"
          />
          <path
            d="M50.9004 24.2385C50.9004 25.3438 50.4808 26.4549 49.6356 27.3001L34.2211 42.7146L31.7801 45.1556L18.3693 58.5605C12.577 52.7269 8.56975 46.4381 5.80957 40.2913L16.3597 29.7411C18.0501 28.0507 20.7867 28.0507 22.4711 29.7411L28.7126 35.9826L43.5123 21.1828C45.1968 19.4983 47.9333 19.4983 49.6237 21.1828C49.7301 21.2892 49.8306 21.3956 49.9193 21.5079C50.5812 22.2999 50.9004 23.2751 50.9004 24.2385Z"
            fill="#01AA28"
          />
          <path
            d="M49.6355 21.1833C47.9452 19.4929 45.2086 19.4929 43.5182 21.1833L28.7244 35.9831L22.477 29.7417C20.7866 28.0513 18.0501 28.0513 16.3597 29.7417C14.6693 31.432 14.6693 34.1686 16.3597 35.859L25.6628 45.1561C26.4725 45.9658 27.5718 46.4209 28.7185 46.4209C29.8651 46.4209 30.9644 45.9658 31.7742 45.1561L49.6296 27.3006C51.3259 25.6102 51.3259 22.8737 49.6355 21.1833Z"
            fill="white"
          />
          <path
            d="M32.9975 66.1031L32.6547 65.8904C21.9982 59.2766 14.0664 50.5527 9.08975 39.9553C3.42163 27.8862 2.93107 16.3017 3.14384 10.4681L3.17339 9.68197L3.94175 9.85337C7.26934 10.5922 11.3416 10.6572 16.0464 10.0484C24.0136 9.02 29.469 6.28937 32.6429 4.17934L33.0034 3.93701L33.364 4.17934C36.5379 6.28937 41.9873 9.02 49.9546 10.0484C54.6593 10.6572 58.7316 10.5922 62.0592 9.85337L62.8276 9.68197L62.8571 10.4681C63.0699 16.3017 62.5793 27.8862 56.9053 39.9553C51.9287 50.5527 44.0028 59.2766 33.3462 65.8904L32.9975 66.1031ZM4.42641 11.2896C4.29047 17.2119 4.96426 28.093 10.2778 39.4056C15.0948 49.6543 22.737 58.1181 33.0034 64.5723C43.264 58.1181 50.9121 49.6484 55.7232 39.4056C61.0367 28.093 61.7046 17.2119 61.5746 11.2896C58.2529 11.9102 54.2929 11.9279 49.7891 11.3487C41.8632 10.3262 36.3369 7.6606 33.0034 5.50919C29.6699 7.6606 24.1378 10.3262 16.2118 11.3487C11.7081 11.9279 7.74808 11.9102 4.42641 11.2896Z"
            fill="white"
          />
        </svg>
      ),
      mainHeading: "Safety First",
      subHeading:
        "Addressing hazards in gas pipelines, fire safety, and sewage treatment to ensure a secure environment.",
      imageSrc: thirdtabimg,
    },
    {
      tabName: "Tab d",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="81"
          height="53"
          viewBox="0 0 81 53"
          fill="none"
        >
          <g clip-path="url(#clip0_251_4602)">
            <path
              d="M40.6424 52.0273C62.9201 52.0273 80.9798 51.3082 80.9798 50.4211C80.9798 49.534 62.9201 48.8149 40.6424 48.8149C18.3647 48.8149 0.305054 49.534 0.305054 50.4211C0.305054 51.3082 18.3647 52.0273 40.6424 52.0273Z"
              fill="#ACB6D9"
            />
            <path
              d="M39.6258 46.9243C39.6258 46.9243 39.3005 47.4529 38.6499 47.7172C37.9993 47.9815 36.5558 47.9612 36.4135 49.2421C36.4135 49.2421 37.247 49.7504 39.7275 49.1811C42.2079 48.6321 42.4722 49.2218 42.6145 48.7338C42.7568 48.2459 42.6552 47.7782 42.3705 47.0463"
              fill="white"
            />
            <path
              d="M30.8832 46.7412C30.8832 46.7412 30.5579 47.2698 29.887 47.5545C29.216 47.8188 27.7319 47.7984 27.6099 49.0996C27.6099 49.0996 28.4638 49.6079 30.9849 49.0387C33.5263 48.4694 33.7906 49.0793 33.9329 48.5914C34.0752 48.1034 33.9736 47.6155 33.6889 46.8632"
              fill="white"
            />
            <path
              d="M29.2365 16.0816C29.2365 16.0816 29.4805 17.6267 28.3826 18.3383C27.5286 18.8873 23.5234 22.059 23.5234 22.059C23.5234 22.059 22.1815 21.998 21.8359 22.3233C21.4902 22.6282 20.5143 23.3805 20.8803 23.4008C21.2666 23.4008 21.5309 23.0755 21.7546 23.2585C21.9782 23.4212 19.9044 24.3971 20.3924 24.4784C20.8803 24.5597 20.3924 24.6614 20.738 24.702C21.0836 24.7427 20.9006 24.8444 21.0633 24.8647C21.2259 24.8647 21.1649 24.946 21.4089 24.9257C21.6326 24.9257 22.6491 24.3971 23.4217 23.5228C24.1943 22.6486 25.5565 22.1606 26.3901 21.7133C27.244 21.266 29.8668 19.5582 30.314 19.1719C30.7613 18.7856 30.6597 18.6433 30.8427 17.8504C31.0256 17.0778 31.3103 15.8579 31.3103 15.8579"
              fill="#F8B992"
            />
            <path
              d="M38.5889 21.002C38.5889 21.002 40.5 23.0351 41.2116 30.639C41.9232 38.2429 43.509 46.4974 43.509 46.4974L39.0971 46.9651L35.7221 28.5042L35.0919 46.8634L30.375 46.8227C30.375 46.8227 30.8223 25.7595 31.3509 22.6285"
              fill="#0076AA"
            />
            <path
              d="M31.168 24.4174L30.436 29.8662H66.8901H73.5181C73.5181 29.8662 73.8841 27.4265 69.9398 25.7593C66.0159 24.0921 61.6446 24.2954 58.9202 23.0755C56.1958 21.8557 51.357 21.7947 49.1815 22.4453C47.0061 23.0755 41.293 23.5838 39.6868 23.8888C38.0806 24.1938 33.3841 23.6652 31.1883 24.2954"
              fill="white"
            />
            <path
              d="M40.866 29.3581C40.866 29.3581 41.5776 29.3988 42.7365 28.4636C43.8953 27.508 46.1318 27.203 48.8359 28.4026C51.5399 29.6021 56.6024 29.6835 58.3509 29.5818C60.1197 29.4801 65.7312 29.8461 65.7312 29.8461L40.2764 29.9884"
              fill="#C9CFE2"
            />
            <path
              d="M45.6032 23.0962C45.6032 23.0962 52.2516 23.3605 52.7598 24.3771C53.2681 25.3936 50.991 25.8003 48.043 24.6414C45.0949 23.4825 44.0784 23.2792 44.0784 23.2792"
              fill="#C9CFE2"
            />
            <path
              opacity="0.6"
              d="M21.1852 25.6576C21.1852 25.6576 22.0798 24.6817 25.2312 25.2713C28.3825 25.861 29.3584 25.4543 29.3584 25.4543C29.3584 25.4543 29.6024 27.3655 31.0053 27.8738C31.0053 27.8738 29.7854 28.565 27.8133 28.4837C25.8411 28.4024 21.5715 28.2804 21.2056 27.1012C20.8599 25.9423 21.1852 25.6576 21.1852 25.6576Z"
              fill="#C9CFE2"
            />
            <path
              d="M18.0949 23.5026C18.0949 23.5026 20.0264 22.73 20.1077 22.669C20.2094 22.6284 20.921 22.9333 22.5881 22.7504C24.2553 22.5674 26.8171 22.2217 28.2402 23.34C29.6634 24.4582 32.1439 24.2142 32.1439 24.2142L32.2659 29.541C32.2659 29.541 24.1333 31.9808 20.86 28.0568L16.7531 25.1291"
              fill="white"
            />
            <path
              d="M19.6604 23.767C19.694 23.767 19.7214 23.7397 19.7214 23.706C19.7214 23.6723 19.694 23.645 19.6604 23.645C19.6267 23.645 19.5994 23.6723 19.5994 23.706C19.5994 23.7397 19.6267 23.767 19.6604 23.767Z"
              fill="#191B1C"
            />
            <path
              d="M20.555 23.1571C20.5887 23.1571 20.616 23.1298 20.616 23.0961C20.616 23.0625 20.5887 23.0352 20.555 23.0352C20.5213 23.0352 20.494 23.0625 20.494 23.0961C20.494 23.1298 20.5213 23.1571 20.555 23.1571Z"
              fill="#191B1C"
            />
            <path
              d="M20.7176 24.3569C20.7513 24.3569 20.7786 24.3295 20.7786 24.2959C20.7786 24.2622 20.7513 24.2349 20.7176 24.2349C20.6839 24.2349 20.6566 24.2622 20.6566 24.2959C20.6566 24.3295 20.6839 24.3569 20.7176 24.3569Z"
              fill="#191B1C"
            />
            <path
              d="M21.0836 23.767C21.1173 23.767 21.1446 23.7397 21.1446 23.706C21.1446 23.6723 21.1173 23.645 21.0836 23.645C21.0499 23.645 21.0226 23.6723 21.0226 23.706C21.0226 23.7397 21.0499 23.767 21.0836 23.767Z"
              fill="#191B1C"
            />
            <path
              d="M21.9781 23.1571C22.0118 23.1571 22.0391 23.1298 22.0391 23.0961C22.0391 23.0625 22.0118 23.0352 21.9781 23.0352C21.9444 23.0352 21.9171 23.0625 21.9171 23.0961C21.9171 23.1298 21.9444 23.1571 21.9781 23.1571Z"
              fill="#191B1C"
            />
            <path
              d="M22.1408 24.3569C22.1745 24.3569 22.2018 24.3295 22.2018 24.2959C22.2018 24.2622 22.1745 24.2349 22.1408 24.2349C22.1071 24.2349 22.0798 24.2622 22.0798 24.2959C22.0798 24.3295 22.1071 24.3569 22.1408 24.3569Z"
              fill="#191B1C"
            />
            <path
              d="M22.3441 23.787C22.3778 23.787 22.4051 23.7597 22.4051 23.726C22.4051 23.6923 22.3778 23.665 22.3441 23.665C22.3104 23.665 22.2831 23.6923 22.2831 23.726C22.2831 23.7597 22.3104 23.787 22.3441 23.787Z"
              fill="#191B1C"
            />
            <path
              d="M23.2387 23.1772C23.2724 23.1772 23.2997 23.1499 23.2997 23.1162C23.2997 23.0825 23.2724 23.0552 23.2387 23.0552C23.205 23.0552 23.1777 23.0825 23.1777 23.1162C23.1777 23.1499 23.205 23.1772 23.2387 23.1772Z"
              fill="#191B1C"
            />
            <path
              d="M23.4013 24.3569C23.435 24.3569 23.4623 24.3295 23.4623 24.2959C23.4623 24.2622 23.435 24.2349 23.4013 24.2349C23.3676 24.2349 23.3403 24.2622 23.3403 24.2959C23.3403 24.3295 23.3676 24.3569 23.4013 24.3569Z"
              fill="#191B1C"
            />
            <path
              d="M23.7673 23.7265C23.801 23.7265 23.8283 23.6992 23.8283 23.6655C23.8283 23.6318 23.801 23.6045 23.7673 23.6045C23.7336 23.6045 23.7063 23.6318 23.7063 23.6655C23.7063 23.6992 23.7336 23.7265 23.7673 23.7265Z"
              fill="#191B1C"
            />
            <path
              d="M24.6619 23.1161C24.6956 23.1161 24.7229 23.0888 24.7229 23.0551C24.7229 23.0214 24.6956 22.9941 24.6619 22.9941C24.6283 22.9941 24.601 23.0214 24.601 23.0551C24.601 23.0888 24.6283 23.1161 24.6619 23.1161Z"
              fill="#191B1C"
            />
            <path
              d="M24.8245 24.2958C24.8582 24.2958 24.8855 24.2685 24.8855 24.2348C24.8855 24.2011 24.8582 24.1738 24.8245 24.1738C24.7909 24.1738 24.7635 24.2011 24.7635 24.2348C24.7635 24.2685 24.7909 24.2958 24.8245 24.2958Z"
              fill="#191B1C"
            />
            <path
              d="M25.1702 23.7265C25.2039 23.7265 25.2312 23.6992 25.2312 23.6655C25.2312 23.6318 25.2039 23.6045 25.1702 23.6045C25.1366 23.6045 25.1093 23.6318 25.1093 23.6655C25.1093 23.6992 25.1366 23.7265 25.1702 23.7265Z"
              fill="#191B1C"
            />
            <path
              d="M26.0648 23.1161C26.0985 23.1161 26.1258 23.0888 26.1258 23.0551C26.1258 23.0214 26.0985 22.9941 26.0648 22.9941C26.0311 22.9941 26.0038 23.0214 26.0038 23.0551C26.0038 23.0888 26.0311 23.1161 26.0648 23.1161Z"
              fill="#191B1C"
            />
            <path
              d="M26.7561 24.7021C26.7897 24.7021 26.8171 24.6748 26.8171 24.6411C26.8171 24.6074 26.7897 24.5801 26.7561 24.5801C26.7224 24.5801 26.6951 24.6074 26.6951 24.6411C26.6951 24.6748 26.7224 24.7021 26.7561 24.7021Z"
              fill="#191B1C"
            />
            <path
              d="M26.573 23.8891C26.6066 23.8891 26.634 23.8618 26.634 23.8281C26.634 23.7944 26.6066 23.7671 26.573 23.7671C26.5393 23.7671 26.512 23.7944 26.512 23.8281C26.512 23.8618 26.5393 23.8891 26.573 23.8891Z"
              fill="#191B1C"
            />
            <path
              d="M19.1522 25.5561C19.1859 25.5561 19.2132 25.5288 19.2132 25.4951C19.2132 25.4614 19.1859 25.4341 19.1522 25.4341C19.1185 25.4341 19.0912 25.4614 19.0912 25.4951C19.0912 25.5288 19.1185 25.5561 19.1522 25.5561Z"
              fill="#191B1C"
            />
            <path
              d="M20.0467 24.9462C20.0804 24.9462 20.1077 24.9189 20.1077 24.8852C20.1077 24.8515 20.0804 24.8242 20.0467 24.8242C20.013 24.8242 19.9857 24.8515 19.9857 24.8852C19.9857 24.9189 20.013 24.9462 20.0467 24.9462Z"
              fill="#191B1C"
            />
            <path
              d="M20.2093 26.1454C20.243 26.1454 20.2703 26.1181 20.2703 26.0844C20.2703 26.0507 20.243 26.0234 20.2093 26.0234C20.1756 26.0234 20.1483 26.0507 20.1483 26.0844C20.1483 26.1181 20.1756 26.1454 20.2093 26.1454Z"
              fill="#191B1C"
            />
            <path
              d="M20.555 25.5561C20.5887 25.5561 20.616 25.5288 20.616 25.4951C20.616 25.4614 20.5887 25.4341 20.555 25.4341C20.5213 25.4341 20.494 25.4614 20.494 25.4951C20.494 25.5288 20.5213 25.5561 20.555 25.5561Z"
              fill="#191B1C"
            />
            <path
              d="M21.4495 24.9462C21.4832 24.9462 21.5105 24.9189 21.5105 24.8852C21.5105 24.8515 21.4832 24.8242 21.4495 24.8242C21.4159 24.8242 21.3885 24.8515 21.3885 24.8852C21.3885 24.9189 21.4159 24.9462 21.4495 24.9462Z"
              fill="#191B1C"
            />
            <path
              d="M21.6325 26.1454C21.6662 26.1454 21.6935 26.1181 21.6935 26.0844C21.6935 26.0507 21.6662 26.0234 21.6325 26.0234C21.5988 26.0234 21.5715 26.0507 21.5715 26.0844C21.5715 26.1181 21.5988 26.1454 21.6325 26.1454Z"
              fill="#191B1C"
            />
            <path
              d="M20.494 27.0199C20.5277 27.0199 20.555 26.9926 20.555 26.9589C20.555 26.9253 20.5277 26.8979 20.494 26.8979C20.4603 26.8979 20.433 26.9253 20.433 26.9589C20.433 26.9926 20.4603 27.0199 20.494 27.0199Z"
              fill="#191B1C"
            />
            <path
              d="M21.8359 25.5766C21.8696 25.5766 21.8969 25.5493 21.8969 25.5156C21.8969 25.4819 21.8696 25.4546 21.8359 25.4546C21.8022 25.4546 21.7749 25.4819 21.7749 25.5156C21.7749 25.5493 21.8022 25.5766 21.8359 25.5766Z"
              fill="#191B1C"
            />
            <path
              d="M22.7304 24.9667C22.7641 24.9667 22.7914 24.9394 22.7914 24.9057C22.7914 24.872 22.7641 24.8447 22.7304 24.8447C22.6967 24.8447 22.6694 24.872 22.6694 24.9057C22.6694 24.9394 22.6967 24.9667 22.7304 24.9667Z"
              fill="#191B1C"
            />
            <path
              d="M22.893 26.1659C22.9267 26.1659 22.954 26.1386 22.954 26.1049C22.954 26.0713 22.9267 26.0439 22.893 26.0439C22.8593 26.0439 22.832 26.0713 22.832 26.1049C22.832 26.1386 22.8593 26.1659 22.893 26.1659Z"
              fill="#191B1C"
            />
            <path
              d="M23.259 25.5155C23.2927 25.5155 23.32 25.4882 23.32 25.4545C23.32 25.4209 23.2927 25.3936 23.259 25.3936C23.2253 25.3936 23.198 25.4209 23.198 25.4545C23.198 25.4882 23.2253 25.5155 23.259 25.5155Z"
              fill="#191B1C"
            />
            <path
              d="M24.1536 24.9057C24.1873 24.9057 24.2146 24.8784 24.2146 24.8447C24.2146 24.811 24.1873 24.7837 24.1536 24.7837C24.12 24.7837 24.0927 24.811 24.0927 24.8447C24.0927 24.8784 24.12 24.9057 24.1536 24.9057Z"
              fill="#191B1C"
            />
            <path
              d="M24.3162 26.0849C24.3499 26.0849 24.3772 26.0576 24.3772 26.0239C24.3772 25.9902 24.3499 25.9629 24.3162 25.9629C24.2826 25.9629 24.2552 25.9902 24.2552 26.0239C24.2552 26.0576 24.2826 26.0849 24.3162 26.0849Z"
              fill="#191B1C"
            />
            <path
              d="M23.6251 27.0199C23.6588 27.0199 23.6861 26.9926 23.6861 26.9589C23.6861 26.9253 23.6588 26.8979 23.6251 26.8979C23.5914 26.8979 23.5641 26.9253 23.5641 26.9589C23.5641 26.9926 23.5914 27.0199 23.6251 27.0199Z"
              fill="#191B1C"
            />
            <path
              d="M24.8245 26.6337C24.8582 26.6337 24.8855 26.6064 24.8855 26.5727C24.8855 26.539 24.8582 26.5117 24.8245 26.5117C24.7909 26.5117 24.7635 26.539 24.7635 26.5727C24.7635 26.6064 24.7909 26.6337 24.8245 26.6337Z"
              fill="#191B1C"
            />
            <path
              d="M24.6619 25.5155C24.6956 25.5155 24.7229 25.4882 24.7229 25.4545C24.7229 25.4209 24.6956 25.3936 24.6619 25.3936C24.6283 25.3936 24.601 25.4209 24.601 25.4545C24.601 25.4882 24.6283 25.5155 24.6619 25.5155Z"
              fill="#191B1C"
            />
            <path
              d="M25.5565 24.9057C25.5902 24.9057 25.6175 24.8784 25.6175 24.8447C25.6175 24.811 25.5902 24.7837 25.5565 24.7837C25.5228 24.7837 25.4955 24.811 25.4955 24.8447C25.4955 24.8784 25.5228 24.9057 25.5565 24.9057Z"
              fill="#191B1C"
            />
            <path
              d="M25.7192 26.4911C25.7529 26.4911 25.7802 26.4638 25.7802 26.4301C25.7802 26.3964 25.7529 26.3691 25.7192 26.3691C25.6855 26.3691 25.6582 26.3964 25.6582 26.4301C25.6582 26.4638 25.6855 26.4911 25.7192 26.4911Z"
              fill="#191B1C"
            />
            <path
              d="M24.9058 27.4472C24.9395 27.4472 24.9668 27.4199 24.9668 27.3862C24.9668 27.3525 24.9395 27.3252 24.9058 27.3252C24.8722 27.3252 24.8448 27.3525 24.8448 27.3862C24.8448 27.4199 24.8722 27.4472 24.9058 27.4472Z"
              fill="#191B1C"
            />
            <path
              d="M26.0648 25.6781C26.0985 25.6781 26.1258 25.6508 26.1258 25.6171C26.1258 25.5835 26.0985 25.5562 26.0648 25.5562C26.0311 25.5562 26.0038 25.5835 26.0038 25.6171C26.0038 25.6508 26.0311 25.6781 26.0648 25.6781Z"
              fill="#191B1C"
            />
            <path
              d="M27.4676 23.2787C27.5013 23.2787 27.5286 23.2514 27.5286 23.2177C27.5286 23.184 27.5013 23.1567 27.4676 23.1567C27.4339 23.1567 27.4066 23.184 27.4066 23.2177C27.4066 23.2514 27.4339 23.2787 27.4676 23.2787Z"
              fill="#191B1C"
            />
            <path
              d="M27.6506 24.1127C27.6843 24.1127 27.7116 24.0854 27.7116 24.0517C27.7116 24.018 27.6843 23.9907 27.6506 23.9907C27.6169 23.9907 27.5896 24.018 27.5896 24.0517C27.5896 24.0854 27.6169 24.1127 27.6506 24.1127Z"
              fill="#191B1C"
            />
            <path
              d="M28.5249 24.1127C28.5585 24.1127 28.5859 24.0854 28.5859 24.0517C28.5859 24.018 28.5585 23.9907 28.5249 23.9907C28.4912 23.9907 28.4639 24.018 28.4639 24.0517C28.4639 24.0854 28.4912 24.1127 28.5249 24.1127Z"
              fill="#191B1C"
            />
            <path
              d="M29.0534 25.0683C29.0871 25.0683 29.1144 25.041 29.1144 25.0073C29.1144 24.9736 29.0871 24.9463 29.0534 24.9463C29.0197 24.9463 28.9924 24.9736 28.9924 25.0073C28.9924 25.041 29.0197 25.0683 29.0534 25.0683Z"
              fill="#191B1C"
            />
            <path
              d="M29.1145 25.9423C29.1481 25.9423 29.1755 25.915 29.1755 25.8813C29.1755 25.8476 29.1481 25.8203 29.1145 25.8203C29.0808 25.8203 29.0535 25.8476 29.0535 25.8813C29.0535 25.915 29.0808 25.9423 29.1145 25.9423Z"
              fill="#191B1C"
            />
            <path
              d="M27.9962 25.2514C28.0299 25.2514 28.0572 25.2241 28.0572 25.1904C28.0572 25.1567 28.0299 25.1294 27.9962 25.1294C27.9625 25.1294 27.9352 25.1567 27.9352 25.1904C27.9352 25.2241 27.9625 25.2514 27.9962 25.2514Z"
              fill="#191B1C"
            />
            <path
              d="M28.1386 26.349C28.1723 26.349 28.1996 26.3217 28.1996 26.288C28.1996 26.2544 28.1723 26.2271 28.1386 26.2271C28.1049 26.2271 28.0776 26.2544 28.0776 26.288C28.0776 26.3217 28.1049 26.349 28.1386 26.349Z"
              fill="#191B1C"
            />
            <path
              d="M26.7561 26.6337C26.7897 26.6337 26.8171 26.6064 26.8171 26.5727C26.8171 26.539 26.7897 26.5117 26.7561 26.5117C26.7224 26.5117 26.6951 26.539 26.6951 26.5727C26.6951 26.6064 26.7224 26.6337 26.7561 26.6337Z"
              fill="#191B1C"
            />
            <path
              d="M27.061 25.8002C27.0947 25.8002 27.122 25.7729 27.122 25.7392C27.122 25.7055 27.0947 25.6782 27.061 25.6782C27.0273 25.6782 27 25.7055 27 25.7392C27 25.7729 27.0273 25.8002 27.061 25.8002Z"
              fill="#191B1C"
            />
            <path
              d="M28.4232 27.1625C28.4569 27.1625 28.4842 27.1352 28.4842 27.1015C28.4842 27.0678 28.4569 27.0405 28.4232 27.0405C28.3895 27.0405 28.3622 27.0678 28.3622 27.1015C28.3622 27.1352 28.3895 27.1625 28.4232 27.1625Z"
              fill="#191B1C"
            />
            <path
              d="M26.0648 27.2235C26.0985 27.2235 26.1258 27.1962 26.1258 27.1626C26.1258 27.1289 26.0985 27.1016 26.0648 27.1016C26.0311 27.1016 26.0038 27.1289 26.0038 27.1626C26.0038 27.1962 26.0311 27.2235 26.0648 27.2235Z"
              fill="#191B1C"
            />
            <path
              d="M22.6491 26.8979C22.6828 26.8979 22.7101 26.8706 22.7101 26.8369C22.7101 26.8032 22.6828 26.7759 22.6491 26.7759C22.6154 26.7759 22.5881 26.8032 22.5881 26.8369C22.5881 26.8706 22.6154 26.8979 22.6491 26.8979Z"
              fill="#191B1C"
            />
            <path
              d="M22.0595 28.0566C22.0932 28.0566 22.1205 28.0293 22.1205 27.9956C22.1205 27.9619 22.0932 27.9346 22.0595 27.9346C22.0258 27.9346 21.9985 27.9619 21.9985 27.9956C21.9985 28.0293 22.0258 28.0566 22.0595 28.0566Z"
              fill="#191B1C"
            />
            <path
              d="M23.0151 27.7929C23.0488 27.7929 23.0761 27.7656 23.0761 27.7319C23.0761 27.6982 23.0488 27.6709 23.0151 27.6709C22.9814 27.6709 22.9541 27.6982 22.9541 27.7319C22.9541 27.7656 22.9814 27.7929 23.0151 27.7929Z"
              fill="#191B1C"
            />
            <path
              d="M21.8359 27.101C21.8696 27.101 21.8969 27.0737 21.8969 27.04C21.8969 27.0063 21.8696 26.979 21.8359 26.979C21.8022 26.979 21.7749 27.0063 21.7749 27.04C21.7749 27.0737 21.8022 27.101 21.8359 27.101Z"
              fill="#191B1C"
            />
            <path
              d="M23.7673 27.7113C23.801 27.7113 23.8283 27.684 23.8283 27.6504C23.8283 27.6167 23.801 27.5894 23.7673 27.5894C23.7336 27.5894 23.7063 27.6167 23.7063 27.6504C23.7063 27.684 23.7336 27.7113 23.7673 27.7113Z"
              fill="#191B1C"
            />
            <path
              d="M23.1574 28.7485C23.1911 28.7485 23.2184 28.7211 23.2184 28.6875C23.2184 28.6538 23.1911 28.6265 23.1574 28.6265C23.1237 28.6265 23.0964 28.6538 23.0964 28.6875C23.0964 28.7211 23.1237 28.7485 23.1574 28.7485Z"
              fill="#191B1C"
            />
            <path
              d="M23.9503 28.911C23.984 28.911 24.0113 28.8837 24.0113 28.8501C24.0113 28.8164 23.984 28.7891 23.9503 28.7891C23.9166 28.7891 23.8893 28.8164 23.8893 28.8501C23.8893 28.8837 23.9166 28.911 23.9503 28.911Z"
              fill="#191B1C"
            />
            <path
              d="M24.5399 28.4228C24.5736 28.4228 24.6009 28.3955 24.6009 28.3618C24.6009 28.3281 24.5736 28.3008 24.5399 28.3008C24.5062 28.3008 24.4789 28.3281 24.4789 28.3618C24.4789 28.3955 24.5062 28.4228 24.5399 28.4228Z"
              fill="#191B1C"
            />
            <path
              d="M25.3735 28.8295C25.4072 28.8295 25.4345 28.8022 25.4345 28.7685C25.4345 28.7348 25.4072 28.7075 25.3735 28.7075C25.3398 28.7075 25.3125 28.7348 25.3125 28.7685C25.3125 28.8022 25.3398 28.8295 25.3735 28.8295Z"
              fill="#191B1C"
            />
            <path
              d="M24.6822 29.7646C24.7159 29.7646 24.7432 29.7373 24.7432 29.7036C24.7432 29.6699 24.7159 29.6426 24.6822 29.6426C24.6485 29.6426 24.6212 29.6699 24.6212 29.7036C24.6212 29.7373 24.6485 29.7646 24.6822 29.7646Z"
              fill="#191B1C"
            />
            <path
              d="M23.7064 29.6425C23.7401 29.6425 23.7674 29.6152 23.7674 29.5815C23.7674 29.5478 23.7401 29.5205 23.7064 29.5205C23.6727 29.5205 23.6454 29.5478 23.6454 29.5815C23.6454 29.6152 23.6727 29.6425 23.7064 29.6425Z"
              fill="#191B1C"
            />
            <path
              d="M25.8614 28.0566C25.8951 28.0566 25.9224 28.0293 25.9224 27.9956C25.9224 27.9619 25.8951 27.9346 25.8614 27.9346C25.8277 27.9346 25.8004 27.9619 25.8004 27.9956C25.8004 28.0293 25.8277 28.0566 25.8614 28.0566Z"
              fill="#191B1C"
            />
            <path
              d="M26.878 28.0566C26.9117 28.0566 26.939 28.0293 26.939 27.9956C26.939 27.9619 26.9117 27.9346 26.878 27.9346C26.8443 27.9346 26.817 27.9619 26.817 27.9956C26.817 28.0293 26.8443 28.0566 26.878 28.0566Z"
              fill="#191B1C"
            />
            <path
              d="M26.3901 28.6669C26.4238 28.6669 26.4511 28.6396 26.4511 28.6059C26.4511 28.5722 26.4238 28.5449 26.3901 28.5449C26.3564 28.5449 26.3291 28.5722 26.3291 28.6059C26.3291 28.6396 26.3564 28.6669 26.3901 28.6669Z"
              fill="#191B1C"
            />
            <path
              d="M26.1665 29.5004C26.2001 29.5004 26.2275 29.4731 26.2275 29.4394C26.2275 29.4057 26.2001 29.3784 26.1665 29.3784C26.1328 29.3784 26.1055 29.4057 26.1055 29.4394C26.1055 29.4731 26.1328 29.5004 26.1665 29.5004Z"
              fill="#191B1C"
            />
            <path
              d="M27.2033 29.5004C27.237 29.5004 27.2643 29.4731 27.2643 29.4394C27.2643 29.4057 27.237 29.3784 27.2033 29.3784C27.1696 29.3784 27.1423 29.4057 27.1423 29.4394C27.1423 29.4731 27.1696 29.5004 27.2033 29.5004Z"
              fill="#191B1C"
            />
            <path
              d="M27.4676 27.2235C27.5013 27.2235 27.5286 27.1962 27.5286 27.1626C27.5286 27.1289 27.5013 27.1016 27.4676 27.1016C27.4339 27.1016 27.4066 27.1289 27.4066 27.1626C27.4066 27.1962 27.4339 27.2235 27.4676 27.2235Z"
              fill="#191B1C"
            />
            <path
              d="M27.6506 28.809C27.6843 28.809 27.7116 28.7817 27.7116 28.748C27.7116 28.7143 27.6843 28.687 27.6506 28.687C27.6169 28.687 27.5896 28.7143 27.5896 28.748C27.5896 28.7817 27.6169 28.809 27.6506 28.809Z"
              fill="#191B1C"
            />
            <path
              d="M26.6748 30.0492C26.7085 30.0492 26.7358 30.0219 26.7358 29.9882C26.7358 29.9546 26.7085 29.9272 26.6748 29.9272C26.6411 29.9272 26.6138 29.9546 26.6138 29.9882C26.6138 30.0219 26.6411 30.0492 26.6748 30.0492Z"
              fill="#191B1C"
            />
            <path
              d="M27.9962 27.996C28.0299 27.996 28.0572 27.9687 28.0572 27.935C28.0572 27.9013 28.0299 27.874 27.9962 27.874C27.9625 27.874 27.9352 27.9013 27.9352 27.935C27.9352 27.9687 27.9625 27.996 27.9962 27.996Z"
              fill="#191B1C"
            />
            <path
              d="M29.5617 26.7758C29.5954 26.7758 29.6227 26.7485 29.6227 26.7148C29.6227 26.6811 29.5954 26.6538 29.5617 26.6538C29.528 26.6538 29.5007 26.6811 29.5007 26.7148C29.5007 26.7485 29.528 26.7758 29.5617 26.7758Z"
              fill="#191B1C"
            />
            <path
              d="M29.1145 27.7929C29.1481 27.7929 29.1755 27.7656 29.1755 27.7319C29.1755 27.6982 29.1481 27.6709 29.1145 27.6709C29.0808 27.6709 29.0535 27.6982 29.0535 27.7319C29.0535 27.7656 29.0808 27.7929 29.1145 27.7929Z"
              fill="#191B1C"
            />
            <path
              d="M29.9074 27.5688C29.9411 27.5688 29.9684 27.5415 29.9684 27.5078C29.9684 27.4741 29.9411 27.4468 29.9074 27.4468C29.8737 27.4468 29.8464 27.4741 29.8464 27.5078C29.8464 27.5415 29.8737 27.5688 29.9074 27.5688Z"
              fill="#191B1C"
            />
            <path
              d="M29.7447 24.9057C29.7784 24.9057 29.8057 24.8784 29.8057 24.8447C29.8057 24.811 29.7784 24.7837 29.7447 24.7837C29.711 24.7837 29.6837 24.811 29.6837 24.8447C29.6837 24.8784 29.711 24.9057 29.7447 24.9057Z"
              fill="#191B1C"
            />
            <path
              d="M30.6392 24.56C30.6729 24.56 30.7002 24.5327 30.7002 24.499C30.7002 24.4653 30.6729 24.438 30.6392 24.438C30.6056 24.438 30.5782 24.4653 30.5782 24.499C30.5782 24.5327 30.6056 24.56 30.6392 24.56Z"
              fill="#191B1C"
            />
            <path
              d="M31.1679 25.5155C31.2016 25.5155 31.2289 25.4882 31.2289 25.4545C31.2289 25.4209 31.2016 25.3936 31.1679 25.3936C31.1342 25.3936 31.1069 25.4209 31.1069 25.4545C31.1069 25.4882 31.1342 25.5155 31.1679 25.5155Z"
              fill="#191B1C"
            />
            <path
              d="M31.6152 24.7631C31.6489 24.7631 31.6762 24.7358 31.6762 24.7021C31.6762 24.6684 31.6489 24.6411 31.6152 24.6411C31.5815 24.6411 31.5542 24.6684 31.5542 24.7021C31.5542 24.7358 31.5815 24.7631 31.6152 24.7631Z"
              fill="#191B1C"
            />
            <path
              d="M30.1108 25.6986C30.1445 25.6986 30.1718 25.6713 30.1718 25.6377C30.1718 25.604 30.1445 25.5767 30.1108 25.5767C30.0771 25.5767 30.0498 25.604 30.0498 25.6377C30.0498 25.6713 30.0771 25.6986 30.1108 25.6986Z"
              fill="#191B1C"
            />
            <path
              d="M31.5542 26.2069C31.5878 26.2069 31.6152 26.1796 31.6152 26.146C31.6152 26.1123 31.5878 26.085 31.5542 26.085C31.5205 26.085 31.4932 26.1123 31.4932 26.146C31.4932 26.1796 31.5205 26.2069 31.5542 26.2069Z"
              fill="#191B1C"
            />
            <path
              d="M30.6392 26.349C30.6729 26.349 30.7002 26.3217 30.7002 26.288C30.7002 26.2544 30.6729 26.2271 30.6392 26.2271C30.6056 26.2271 30.5782 26.2544 30.5782 26.288C30.5782 26.3217 30.6056 26.349 30.6392 26.349Z"
              fill="#191B1C"
            />
            <path
              d="M31.4932 26.8168C31.5269 26.8168 31.5542 26.7895 31.5542 26.7558C31.5542 26.7221 31.5269 26.6948 31.4932 26.6948C31.4596 26.6948 31.4323 26.7221 31.4323 26.7558C31.4323 26.7895 31.4596 26.8168 31.4932 26.8168Z"
              fill="#191B1C"
            />
            <path
              d="M30.436 26.9999C30.4697 26.9999 30.497 26.9726 30.497 26.9389C30.497 26.9052 30.4697 26.8779 30.436 26.8779C30.4023 26.8779 30.375 26.9052 30.375 26.9389C30.375 26.9726 30.4023 26.9999 30.436 26.9999Z"
              fill="#191B1C"
            />
            <path
              d="M31.8795 27.5082C31.9132 27.5082 31.9405 27.4809 31.9405 27.4472C31.9405 27.4135 31.9132 27.3862 31.8795 27.3862C31.8458 27.3862 31.8185 27.4135 31.8185 27.4472C31.8185 27.4809 31.8458 27.5082 31.8795 27.5082Z"
              fill="#191B1C"
            />
            <path
              d="M30.9849 27.6503C31.0186 27.6503 31.0459 27.623 31.0459 27.5893C31.0459 27.5556 31.0186 27.5283 30.9849 27.5283C30.9513 27.5283 30.924 27.5556 30.924 27.5893C30.924 27.623 30.9513 27.6503 30.9849 27.6503Z"
              fill="#191B1C"
            />
            <path
              d="M28.5655 28.4027C28.5992 28.4027 28.6265 28.3754 28.6265 28.3418C28.6265 28.3081 28.5992 28.2808 28.5655 28.2808C28.5318 28.2808 28.5045 28.3081 28.5045 28.3418C28.5045 28.3754 28.5318 28.4027 28.5655 28.4027Z"
              fill="#191B1C"
            />
            <path
              d="M28.2606 29.7851C28.2943 29.7851 28.3216 29.7578 28.3216 29.7241C28.3216 29.6904 28.2943 29.6631 28.2606 29.6631C28.2269 29.6631 28.1996 29.6904 28.1996 29.7241C28.1996 29.7578 28.2269 29.7851 28.2606 29.7851Z"
              fill="#191B1C"
            />
            <path
              d="M29.2365 29.0736C29.2702 29.0736 29.2975 29.0463 29.2975 29.0127C29.2975 28.979 29.2702 28.9517 29.2365 28.9517C29.2028 28.9517 29.1755 28.979 29.1755 29.0127C29.1755 29.0463 29.2028 29.0736 29.2365 29.0736Z"
              fill="#191B1C"
            />
            <path
              d="M29.0534 29.8461C29.0871 29.8461 29.1144 29.8188 29.1144 29.7851C29.1144 29.7514 29.0871 29.7241 29.0534 29.7241C29.0197 29.7241 28.9924 29.7514 28.9924 29.7851C28.9924 29.8188 29.0197 29.8461 29.0534 29.8461Z"
              fill="#191B1C"
            />
            <path
              d="M29.8057 29.724C29.8394 29.724 29.8667 29.6967 29.8667 29.663C29.8667 29.6294 29.8394 29.6021 29.8057 29.6021C29.7721 29.6021 29.7448 29.6294 29.7448 29.663C29.7448 29.6967 29.7721 29.724 29.8057 29.724Z"
              fill="#191B1C"
            />
            <path
              d="M30.1513 28.3417C30.185 28.3417 30.2123 28.3144 30.2123 28.2807C30.2123 28.247 30.185 28.2197 30.1513 28.2197C30.1176 28.2197 30.0903 28.247 30.0903 28.2807C30.0903 28.3144 30.1176 28.3417 30.1513 28.3417Z"
              fill="#191B1C"
            />
            <path
              d="M31.3103 28.5859C31.3439 28.5859 31.3713 28.5585 31.3713 28.5249C31.3713 28.4912 31.3439 28.4639 31.3103 28.4639C31.2766 28.4639 31.2493 28.4912 31.2493 28.5249C31.2493 28.5585 31.2766 28.5859 31.3103 28.5859Z"
              fill="#191B1C"
            />
            <path
              d="M30.1513 29.0326C30.185 29.0326 30.2123 29.0053 30.2123 28.9716C30.2123 28.938 30.185 28.9106 30.1513 28.9106C30.1176 28.9106 30.0903 28.938 30.0903 28.9716C30.0903 29.0053 30.1176 29.0326 30.1513 29.0326Z"
              fill="#191B1C"
            />
            <path
              d="M30.8426 29.5004C30.8763 29.5004 30.9036 29.4731 30.9036 29.4394C30.9036 29.4057 30.8763 29.3784 30.8426 29.3784C30.8089 29.3784 30.7816 29.4057 30.7816 29.4394C30.7816 29.4731 30.8089 29.5004 30.8426 29.5004Z"
              fill="#191B1C"
            />
            <path
              opacity="0.6"
              d="M26.0445 25.2514C26.0445 25.2514 28.4232 25.1904 29.5618 24.8448C30.7207 24.4991 31.8389 23.9299 32.6928 23.9909C32.6928 23.9909 31.2899 25.3327 30.497 25.5564C29.7041 25.7597 25.7802 25.7597 25.7802 25.7597"
              fill="#C9CFE2"
            />
            <path
              d="M13.6626 18.0744C13.6626 18.0744 15.4111 17.2815 16.4887 18.481C16.4887 18.481 16.9563 18.9893 17.6069 19.1723C18.7048 19.4773 19.6197 21.917 17.9322 22.7303C15.6957 23.8078 13.7236 21.4291 13.7236 21.4291"
              fill="#F8B992"
            />
            <path
              d="M39.0971 16.326C39.0971 16.326 40.256 17.3832 39.8087 18.6234C39.4631 19.5993 38.3042 24.5602 38.3042 24.5602C38.3042 24.5602 37.2266 25.3531 37.1453 25.8004C37.064 26.268 36.759 27.4675 37.064 27.2236C37.369 26.9999 37.3893 26.573 37.6536 26.573C37.9382 26.573 36.9217 28.6264 37.3486 28.3825C37.7756 28.1385 37.4706 28.5248 37.7553 28.3418C38.0399 28.1588 37.9586 28.3621 38.1009 28.2605C38.2432 28.1588 38.2229 28.2605 38.4059 28.0978C38.5888 27.9555 39.0565 26.9186 39.1174 25.7597C39.1784 24.6008 39.9307 23.3606 40.3373 22.4864C40.7236 21.6121 41.7402 18.6234 41.8418 18.0541C41.9435 17.4849 41.7809 17.4239 41.4556 16.6919C41.1302 15.96 40.5813 14.8418 40.5813 14.8418"
              fill="#F8B992"
            />
            <path
              d="M30.7003 7.60376C30.7003 7.60376 31.5746 8.478 31.3103 9.65722C31.0256 10.8364 31.0256 10.8364 31.0256 10.8364C31.0256 10.8364 33.4857 10.7144 34.1973 8.88463C34.1973 8.88463 32.7334 8.59999 33.1807 5.55029"
              fill="#DD9B7A"
            />
            <path
              d="M29.5414 11.6289L28.5452 16.4881L31.7575 16.976"
              fill="#0076AA"
            />
            <path
              d="M39.0159 21.5714C38.6499 20.8802 38.04 19.4163 37.3487 16.3463L37.1657 15.1874C37.1657 15.1874 37.8773 16.204 38.2839 17.2409L41.0897 15.2077C41.0897 15.2077 39.0769 10.9788 36.9827 9.25066C36.9827 9.25066 36.2305 8.76271 35.1732 8.68138C34.116 8.57973 33.6077 8.53906 33.6077 8.53906C33.6077 8.53906 33.3231 9.96226 31.7576 10.6942C31.7576 10.6942 31.107 10.5112 31.3306 9.35232C31.3306 9.35232 29.8464 10.1046 29.6838 10.8772C29.5211 11.6294 28.6266 14.2522 30.1107 16.6309C31.4729 18.8267 31.107 23.9909 31.107 23.9909C31.107 23.9909 35.0716 24.6211 38.7719 22.527L39.0159 21.5714Z"
              fill="#017FC2"
            />
            <path
              d="M30.7614 16.8137C30.7614 16.8137 31.3916 16.1834 32.6318 16.2647C33.872 16.3461 35.1936 16.2851 36.2915 14.6992C36.2915 14.6992 36.3118 16.9357 34.7463 16.956C33.1808 16.9763 32.5098 16.3664 30.7614 16.8137Z"
              fill="#0076AA"
            />
            <path
              d="M33.7093 8.51881C34.8478 8.35616 34.6242 10.125 34.6242 10.8162C34.6242 11.4872 34.6242 12.1581 34.6039 12.8291C34.6039 12.9917 34.8478 12.9917 34.8682 12.8291C34.8885 11.6905 34.9088 10.5519 34.8682 9.43372C34.8478 8.70179 34.4412 8.15285 33.6483 8.27483C33.4856 8.29516 33.5466 8.53914 33.7093 8.51881Z"
              fill="#191B1C"
            />
            <path
              d="M33.6484 18.4811C32.8758 18.1354 33.1401 15.838 33.1604 15.7363L33.2621 15.7567C33.2621 15.777 32.9774 18.0744 33.689 18.3794L33.6484 18.4811Z"
              fill="white"
            />
            <path
              d="M34.7869 18.4808L34.7666 18.3791C35.5189 18.1555 35.5392 15.858 35.5392 15.8174H35.6408C35.6408 15.9394 35.6002 18.2571 34.7869 18.4808Z"
              fill="white"
            />
            <path
              d="M33.6687 18.6641C33.7922 18.6641 33.8924 18.564 33.8924 18.4404C33.8924 18.3169 33.7922 18.2168 33.6687 18.2168C33.5452 18.2168 33.4451 18.3169 33.4451 18.4404C33.4451 18.564 33.5452 18.6641 33.6687 18.6641Z"
              fill="#191B1C"
            />
            <path
              d="M34.7056 18.6641C34.8291 18.6641 34.9292 18.564 34.9292 18.4404C34.9292 18.3169 34.8291 18.2168 34.7056 18.2168C34.5821 18.2168 34.4819 18.3169 34.4819 18.4404C34.4819 18.564 34.5821 18.6641 34.7056 18.6641Z"
              fill="#191B1C"
            />
            <path
              d="M33.3434 15.7766C33.3637 14.943 33.5467 13.1132 34.6446 13.0522C35.7832 12.9912 35.4985 15.2277 35.4375 15.8376C35.4172 16.0003 35.6815 16.0003 35.7018 15.8376C35.7832 15.2073 36.0271 12.7472 34.7463 12.8082C33.3637 12.8692 33.1198 14.6787 33.0791 15.7766C33.0791 15.9393 33.3434 15.9393 33.3434 15.7766Z"
              fill="#191B1C"
            />
            <path
              d="M29.9683 1.91079C29.9683 1.91079 28.6265 2.70371 28.5858 4.16757C28.5452 5.63142 28.4028 7.21727 29.9683 8.29483C31.5339 9.35206 32.6927 7.35959 32.8147 5.73308C32.9164 4.12691 32.5911 1.82947 29.9683 1.91079Z"
              fill="#F8B992"
            />
            <path
              d="M32.4487 5.73331C32.4487 5.71297 32.591 4.87939 33.0383 5.0827C33.4856 5.26568 33.2417 6.40424 32.5707 6.66855"
              fill="#F8B992"
            />
            <path
              d="M29.7854 7.56274L30.924 7.19678C30.924 7.19678 30.6393 8.33533 29.7854 7.56274Z"
              fill="white"
            />
            <path
              d="M30.6596 5.67198C30.727 5.67198 30.7816 5.59916 30.7816 5.50933C30.7816 5.4195 30.727 5.34668 30.6596 5.34668C30.5922 5.34668 30.5376 5.4195 30.5376 5.50933C30.5376 5.59916 30.5922 5.67198 30.6596 5.67198Z"
              fill="black"
            />
            <path
              d="M28.9925 6.11925C29.0598 6.11925 29.1145 6.04643 29.1145 5.9566C29.1145 5.86677 29.0598 5.79395 28.9925 5.79395C28.9251 5.79395 28.8705 5.86677 28.8705 5.9566C28.8705 6.04643 28.9251 6.11925 28.9925 6.11925Z"
              fill="black"
            />
            <path
              d="M29.7244 5.85547L29.6837 6.79071C29.6837 6.79071 29.643 7.05502 30.131 6.9127"
              fill="#DD9B7A"
            />
            <path
              d="M30.1107 5.00124C30.4563 4.79793 30.9239 4.79793 31.2899 4.83859C31.3509 4.83859 31.3509 4.73693 31.2899 4.73693C30.8833 4.69627 30.4157 4.7166 30.0497 4.91992C30.009 4.94025 30.0497 5.0419 30.1107 5.00124Z"
              fill="#191B1C"
            />
            <path
              d="M28.3418 5.4686C28.5451 5.28562 28.8298 5.28562 29.0534 5.32629C29.0941 5.32629 29.0941 5.22463 29.0534 5.22463C28.8094 5.18397 28.5248 5.2043 28.3011 5.38728C28.2605 5.40761 28.3011 5.48894 28.3418 5.4686Z"
              fill="#191B1C"
            />
            <path
              d="M30.436 1.5854C30.436 1.5854 30.9037 -0.325742 33.0994 0.0402214C34.5836 0.304529 34.7056 1.70739 34.665 2.35799C34.6243 3.0086 34.238 3.2729 34.8479 4.14715C35.4579 5.0214 34.8886 5.18405 34.7869 5.73299C34.6853 6.28194 34.8479 6.7089 35.1326 6.79022C35.1326 6.79022 33.75 6.93254 33.6687 5.65167"
              fill="#191B1C"
            />
            <path
              d="M29.3178 3.61848C29.3178 3.61848 29.6837 4.37074 30.7816 4.77736C31.8795 5.16366 32.3675 5.46863 32.8148 6.18022C33.0384 6.54619 32.8961 6.89182 33.0181 7.03414C33.2011 7.23745 33.445 6.50552 33.567 6.18022C33.689 5.81426 33.9127 5.99724 33.75 3.98444C33.5874 1.97164 32.1235 1.15839 30.7003 1.40236C29.2771 1.66667 28.1386 2.6629 28.0369 4.04543C28.0369 4.04543 27.9149 5.36697 28.5655 5.95658C28.5655 5.95658 28.4232 5.04167 28.7282 4.63504C29.0738 4.22842 29.3178 3.67947 29.3178 3.61848Z"
              fill="#191B1C"
            />
            <path
              d="M24.5399 30.1919L9.12876 19.152C8.4375 18.664 7.50226 18.8064 7.0143 19.4976C6.52635 20.1686 6.689 21.1241 7.38027 21.6121L22.7914 32.652L24.5399 30.1919Z"
              fill="#ACB6D9"
            />
            <path
              d="M28.5858 25.9225C28.5858 25.9225 30.9036 25.3938 31.4932 24.7839C32.0828 24.174 33.0587 23.4014 33.9533 23.4014C34.8479 23.4014 35.4578 23.4827 35.7424 23.808C36.0067 24.1333 34.7869 23.625 34.2583 24.6009C33.7296 25.5972 32.6521 26.7357 32.6521 26.7357C32.6521 26.7357 31.2289 27.8946 30.131 27.8743"
              fill="#F8B992"
            />
            <path
              d="M21.4698 24.7223C21.4698 24.7223 22.4457 23.8277 25.5361 24.7223C28.6265 25.6169 29.643 25.4339 29.643 25.4339C29.643 25.4339 29.6837 27.2434 31.0459 27.894C31.0459 27.894 29.765 28.4633 27.8132 28.199C25.8614 27.9346 21.6325 27.3857 21.3682 26.1862C21.0835 24.9663 21.4698 24.7223 21.4698 24.7223Z"
              fill="white"
            />
            <path
              d="M23.1168 26.349C23.1505 26.349 23.1778 26.3217 23.1778 26.288C23.1778 26.2544 23.1505 26.2271 23.1168 26.2271C23.0831 26.2271 23.0558 26.2544 23.0558 26.288C23.0558 26.3217 23.0831 26.349 23.1168 26.349Z"
              fill="#191B1C"
            />
            <path
              d="M22.2832 25.0888C22.3168 25.0888 22.3442 25.0615 22.3442 25.0278C22.3442 24.9941 22.3168 24.9668 22.2832 24.9668C22.2495 24.9668 22.2222 24.9941 22.2222 25.0278C22.2222 25.0615 22.2495 25.0888 22.2832 25.0888Z"
              fill="#191B1C"
            />
            <path
              d="M24.1129 25.0888C24.1466 25.0888 24.1739 25.0615 24.1739 25.0278C24.1739 24.9941 24.1466 24.9668 24.1129 24.9668C24.0792 24.9668 24.0519 24.9941 24.0519 25.0278C24.0519 25.0615 24.0792 25.0888 24.1129 25.0888Z"
              fill="#191B1C"
            />
            <path
              d="M25.3939 25.8002C25.4276 25.8002 25.4549 25.7729 25.4549 25.7392C25.4549 25.7055 25.4276 25.6782 25.3939 25.6782C25.3602 25.6782 25.3329 25.7055 25.3329 25.7392C25.3329 25.7729 25.3602 25.8002 25.3939 25.8002Z"
              fill="#191B1C"
            />
            <path
              d="M26.878 26.9794C26.9117 26.9794 26.939 26.9521 26.939 26.9184C26.939 26.8847 26.9117 26.8574 26.878 26.8574C26.8443 26.8574 26.817 26.8847 26.817 26.9184C26.817 26.9521 26.8443 26.9794 26.878 26.9794Z"
              fill="#191B1C"
            />
            <path
              d="M29.3991 27.5082C29.4328 27.5082 29.4601 27.4809 29.4601 27.4472C29.4601 27.4135 29.4328 27.3862 29.3991 27.3862C29.3654 27.3862 29.3381 27.4135 29.3381 27.4472C29.3381 27.4809 29.3654 27.5082 29.3991 27.5082Z"
              fill="#191B1C"
            />
            <path
              d="M28.2606 27.8334C28.2943 27.8334 28.3216 27.8061 28.3216 27.7724C28.3216 27.7387 28.2943 27.7114 28.2606 27.7114C28.2269 27.7114 28.1996 27.7387 28.1996 27.7724C28.1996 27.8061 28.2269 27.8334 28.2606 27.8334Z"
              fill="#191B1C"
            />
            <path
              d="M27.0203 25.495C27.054 25.495 27.0813 25.4677 27.0813 25.434C27.0813 25.4004 27.054 25.373 27.0203 25.373C26.9867 25.373 26.9594 25.4004 26.9594 25.434C26.9594 25.4677 26.9867 25.495 27.0203 25.495Z"
              fill="#191B1C"
            />
            <path
              d="M28.5045 26.227C28.5382 26.227 28.5655 26.1997 28.5655 26.166C28.5655 26.1323 28.5382 26.105 28.5045 26.105C28.4708 26.105 28.4435 26.1323 28.4435 26.166C28.4435 26.1997 28.4708 26.227 28.5045 26.227Z"
              fill="#191B1C"
            />
            <path
              d="M24.8856 27.1625C24.9193 27.1625 24.9466 27.1352 24.9466 27.1015C24.9466 27.0678 24.9193 27.0405 24.8856 27.0405C24.8519 27.0405 24.8246 27.0678 24.8246 27.1015C24.8246 27.1352 24.8519 27.1625 24.8856 27.1625Z"
              fill="#191B1C"
            />
            <path
              d="M13.744 17.6881C13.744 17.6881 15.8991 17.4238 16.4684 18.7657C16.9767 19.9652 17.546 20.7581 18.5625 21.1851C19.5791 21.612 20.3314 22.283 20.8803 23.1979C21.4089 24.1128 22.3442 23.9502 23.2997 23.6045C24.2553 23.2792 25.3735 23.4012 25.4752 23.7265C25.5769 24.0518 24.4993 23.3809 24.1537 24.3974C23.808 25.3937 22.0799 26.2679 20.4737 25.475C20.4737 25.475 19.1522 24.7634 18.0949 25.3123C17.0377 25.8613 13.9677 25.6377 13.6627 23.7875C13.3577 21.9373 11.7109 23.7875 11.2839 20.9208C10.857 18.0947 13.744 17.6881 13.744 17.6881Z"
              fill="#191B1C"
            />
            <path
              d="M71.302 44.5049C71.0784 44.5049 70.8547 44.5049 70.6108 44.5049C68.7809 42.0651 66.9511 39.6254 65.1213 37.206C64.552 36.4537 63.2712 37.1856 63.8404 37.9582C65.4873 40.154 67.1341 42.3294 68.7809 44.5252C55.1386 44.5252 41.5166 44.5252 27.8743 44.5252C22.4662 44.5252 17.0581 44.5252 11.6499 44.5252C13.2968 42.3294 14.9436 40.154 16.5904 37.9582C17.1597 37.1856 15.8788 36.4537 15.3096 37.206C13.4797 39.6457 11.6499 42.0855 9.8201 44.5049C9.65745 44.5049 9.47447 44.5049 9.31182 44.5049C8.90519 44.5049 8.57989 44.8505 8.57989 45.2368C8.57989 45.5825 8.57989 45.9281 8.57989 46.2737C8.55956 46.416 8.57989 46.5584 8.64088 46.66C8.76287 46.9243 9.02718 47.1073 9.31182 47.1073C23.7877 47.1073 38.2636 47.1073 52.7599 47.1073C58.9609 47.1073 65.162 47.1073 71.3427 47.1073C71.5663 47.1073 71.729 47.026 71.851 46.904L71.8713 46.8837L71.8916 46.8633C72.0136 46.7413 72.095 46.5787 72.095 46.355C72.095 45.9688 72.095 45.6028 72.095 45.2165C72.034 44.8302 71.7087 44.5049 71.302 44.5049Z"
              fill="#979FB7"
            />
            <path
              d="M12.6054 51.702C14.3795 51.702 15.8178 50.2638 15.8178 48.4897C15.8178 46.7156 14.3795 45.2773 12.6054 45.2773C10.8313 45.2773 9.39307 46.7156 9.39307 48.4897C9.39307 50.2638 10.8313 51.702 12.6054 51.702Z"
              fill="#191B1C"
            />
            <path
              d="M12.6054 50.3399C13.6609 50.3399 14.5165 49.4842 14.5165 48.4287C14.5165 47.3732 13.6609 46.5176 12.6054 46.5176C11.5499 46.5176 10.6942 47.3732 10.6942 48.4287C10.6942 49.4842 11.5499 50.3399 12.6054 50.3399Z"
              fill="white"
            />
            <path
              d="M12.6054 48.9777C12.9423 48.9777 13.2154 48.7046 13.2154 48.3678C13.2154 48.0309 12.9423 47.7578 12.6054 47.7578C12.2686 47.7578 11.9955 48.0309 11.9955 48.3678C11.9955 48.7046 12.2686 48.9777 12.6054 48.9777Z"
              fill="#191B1C"
            />
            <path
              d="M68.6791 51.702C70.4533 51.702 71.8915 50.2638 71.8915 48.4897C71.8915 46.7156 70.4533 45.2773 68.6791 45.2773C66.905 45.2773 65.4668 46.7156 65.4668 48.4897C65.4668 50.2638 66.905 51.702 68.6791 51.702Z"
              fill="#191B1C"
            />
            <path
              d="M68.6792 50.3399C69.7347 50.3399 70.5904 49.4842 70.5904 48.4287C70.5904 47.3732 69.7347 46.5176 68.6792 46.5176C67.6237 46.5176 66.7681 47.3732 66.7681 48.4287C66.7681 49.4842 67.6237 50.3399 68.6792 50.3399Z"
              fill="white"
            />
            <path
              d="M68.6792 48.9777C69.016 48.9777 69.2891 48.7046 69.2891 48.3678C69.2891 48.0309 69.016 47.7578 68.6792 47.7578C68.3423 47.7578 68.0692 48.0309 68.0692 48.3678C68.0692 48.7046 68.3423 48.9777 68.6792 48.9777Z"
              fill="#191B1C"
            />
            <path
              d="M78.174 18.481C77.0964 18.481 76.2425 19.1722 76.2425 20.0058V34.441H3.86295V20.0058C3.86295 19.1722 2.9887 18.481 1.93148 18.481C0.874247 18.481 0 19.1722 0 20.0058V38.9749H3.55798H3.86295H76.2425H78.174H80.1054V20.0058C80.1054 19.1722 79.2312 18.481 78.174 18.481Z"
              fill="#979FB7"
            />
            <path
              d="M76.2425 35.0307C76.2425 35.6203 75.7749 36.0879 75.1853 36.0879H4.6356C4.04599 36.0879 3.57837 35.6203 3.57837 35.0307V30.9034C3.57837 30.3138 4.04599 29.8462 4.6356 29.8462H75.1853C75.7749 29.8462 76.2425 30.3138 76.2425 30.9034V35.0307Z"
              fill="#ACB6D9"
            />
            <path
              d="M70.8953 29.3782C69.7771 25.8812 66.4631 25.4136 63.3321 25.4136C60.0994 25.4136 56.8667 25.4136 53.6544 25.4136C44.302 25.4136 34.9496 25.4136 25.5972 25.4136C22.5068 25.4136 19.4164 25.4136 16.3261 25.4136C15.8381 25.4136 15.3502 25.4136 14.8622 25.4136C12.4631 25.4136 8.9458 27.1824 8.9458 30.0085C8.9458 31.8993 8.9458 33.7901 8.9458 35.6809C8.9458 37.0228 8.9458 38.6289 10.796 38.6289C12.5444 38.6289 14.2929 38.6289 16.0618 38.6289C32.7741 38.6289 49.4865 38.6289 66.1988 38.6289C67.195 38.6289 69.1062 38.9746 70.0414 38.4663C71.485 37.6734 71.058 35.7826 71.058 34.3797C71.058 32.7938 71.363 30.8827 70.8953 29.3782ZM68.8216 37.1244C66.5648 37.1244 64.2877 37.1244 62.0309 37.1244C53.0241 37.1244 43.997 37.1244 34.9902 37.1244C27.5083 37.1244 20.0264 37.1244 12.5444 37.1244C11.9752 37.1244 11.4059 37.1244 10.8163 37.1244C10.0437 37.1244 10.43 33.5054 10.43 32.9158C10.43 32.0213 10.43 31.1267 10.43 30.2321C10.43 28.5446 12.3005 27.406 13.7237 27.0197C14.4353 26.8368 15.2688 26.8978 16.0211 26.8978C23.7877 26.8978 31.5542 26.8978 39.3208 26.8978V36.1485H40.8863V26.8978C48.2463 26.8978 55.6265 26.8978 62.9865 26.8978C65.5075 26.8978 68.5369 26.7961 69.4925 29.7645C69.6958 30.3947 69.5941 31.1267 69.5941 31.7976C69.5941 32.9972 69.5941 34.217 69.5941 35.4166C69.5738 36.3112 69.8381 37.1244 68.8216 37.1244Z"
              fill="#979FB7"
            />
          </g>
          <defs>
            <clipPath id="clip0_251_4602">
              <rect width="81" height="52.0279" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      mainHeading: "Operational Smooth Sailing",
      subHeading:
        "Overcoming hurdles in operational critical services like OTs, transplant units, and ICUs.",
      imageSrc: fourthtabimg,
    },
  ];
  const cardData = [
    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="39" cy="61" r="29" fill="#EDD696" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.7732 62.4133H18.278V65.2642H42.7732V62.4133ZM40.9844 67.2638H20.0668V69.7868H40.9844V67.266V67.2638ZM24.48 71.7865V72.2501C24.4822 72.9785 24.7724 73.6764 25.2873 74.1916C25.8021 74.7068 26.4997 74.9974 27.228 75H33.8239C34.5517 74.9972 35.2488 74.7068 35.7634 74.1921C36.278 73.6774 36.5684 72.9801 36.5712 72.2523V71.7886L24.48 71.7865ZM33.4442 44.0987H35.5204C35.9312 44.0988 36.3328 43.9771 36.6744 43.7489C37.0161 43.5207 37.2824 43.1963 37.4397 42.8167C37.5969 42.4372 37.6381 42.0194 37.558 41.6165C37.4779 41.2135 37.2801 40.8433 36.9896 40.5527C36.6991 40.2622 36.329 40.0644 35.9261 39.9842C35.5231 39.9041 35.1055 39.9453 34.726 40.1026C34.3465 40.2599 34.0221 40.5263 33.794 40.868C33.5658 41.2096 33.4441 41.6113 33.4442 42.0222V44.0987ZM27.5529 44.0987V42.0222C27.5529 41.6115 27.4312 41.2101 27.203 40.8686C26.9749 40.5271 26.6507 40.261 26.2713 40.1038C25.8919 39.9467 25.4745 39.9056 25.0718 39.9857C24.6691 40.0658 24.2991 40.2636 24.0088 40.554C23.7184 40.8444 23.5207 41.2143 23.4406 41.6171C23.3605 42.0199 23.4016 42.4374 23.5587 42.8168C23.7159 43.1963 23.982 43.5206 24.3234 43.7487C24.6648 43.9769 25.0662 44.0987 25.4768 44.0987H27.5529ZM31.4442 60.4158V46.0983H29.553V60.4158H31.4442ZM27.5529 60.4158H20.2759C20.2013 60.3071 20.137 60.1916 20.0839 60.0709C19.9781 59.8332 19.9178 59.5778 19.9061 59.3179C19.8661 58.2621 19.6301 57.2231 19.2101 56.2537C18.7786 55.2812 18.1731 54.3958 17.4233 53.6411C14.8997 51.0658 13.1925 47.8026 12.5158 44.2608C11.8391 40.7189 12.223 37.0561 13.6194 33.7316C15.0159 30.4072 17.3626 27.5691 20.3654 25.5733C23.3681 23.5774 26.8932 22.5128 30.4986 22.5128C34.1039 22.5128 37.629 23.5774 40.6318 25.5733C43.6346 27.5691 45.9813 30.4072 47.3777 33.7316C48.7741 37.0561 49.1581 40.7189 48.4814 44.2608C47.8047 47.8026 46.0974 51.0658 43.5738 53.6411C42.8241 54.3958 42.2186 55.2812 41.7871 56.2537C41.3671 57.2231 41.131 58.2621 41.091 59.3179C41.0722 59.7112 40.9439 60.0915 40.7206 60.4158H33.4442V46.0983H35.5204C36.3264 46.0982 37.1142 45.859 37.7843 45.411C38.4545 44.9631 38.9767 44.3264 39.2851 43.5816C39.5934 42.8368 39.674 42.0172 39.5167 41.2266C39.3593 40.4359 38.9711 39.7097 38.4012 39.1397C37.8312 38.5698 37.105 38.1816 36.3145 38.0244C35.5239 37.8672 34.7045 37.9479 33.9599 38.2565C33.2152 38.565 32.5788 39.0874 32.131 39.7577C31.6832 40.428 31.4442 41.2161 31.4442 42.0222V44.0987H29.553V42.0222C29.5531 41.2159 29.3141 40.4276 28.8663 39.7571C28.4185 39.0866 27.782 38.5639 27.0372 38.2552C26.2924 37.9466 25.4728 37.8657 24.682 38.023C23.8913 38.1802 23.1649 38.5684 22.5948 39.1385C22.0247 39.7087 21.6364 40.4351 21.479 41.2259C21.3217 42.0167 21.4024 42.8365 21.7109 43.5815C22.0194 44.3265 22.5418 44.9632 23.2121 45.4112C23.8825 45.8592 24.6706 46.0983 25.4768 46.0983H27.5529V60.4158ZM29.4989 11.9998C29.4989 11.7347 29.6042 11.4803 29.7917 11.2928C29.9792 11.1053 30.2335 11 30.4986 11C30.7637 11 31.018 11.1053 31.2054 11.2928C31.3929 11.4803 31.4982 11.7347 31.4982 11.9998V16.2146C31.4982 16.4797 31.3929 16.7341 31.2054 16.9216C31.018 17.1091 30.7637 17.2144 30.4986 17.2144C30.2335 17.2144 29.9792 17.1091 29.7917 16.9216C29.6042 16.7341 29.4989 16.4797 29.4989 16.2146V11.9998ZM14.8993 16.445C14.7678 16.216 14.7326 15.9442 14.8014 15.6893C14.8703 15.4343 15.0376 15.2172 15.2665 15.0857C15.4955 14.9541 15.7673 14.9189 16.0221 14.9878C16.277 15.0567 16.4941 15.224 16.6256 15.453L18.733 19.1067C18.7981 19.22 18.8403 19.3451 18.8571 19.4748C18.8739 19.6045 18.865 19.7362 18.8309 19.8624C18.7968 19.9886 18.7381 20.1069 18.6583 20.2104C18.5785 20.314 18.4791 20.4008 18.3658 20.466C18.2524 20.5311 18.1274 20.5733 17.9977 20.5901C17.8681 20.6068 17.7364 20.5979 17.6102 20.5638C17.484 20.5297 17.3657 20.4711 17.2622 20.3913C17.1586 20.3115 17.0718 20.212 17.0067 20.0987L14.8993 16.445ZM4.47609 27.6016C4.24716 27.4696 4.08006 27.252 4.01152 26.9968C3.94298 26.7415 3.97864 26.4695 4.11063 26.2405C4.24263 26.0116 4.46016 25.8444 4.71537 25.7759C4.97058 25.7073 5.24256 25.743 5.47148 25.875L9.12103 27.982C9.34995 28.1141 9.51706 28.3316 9.5856 28.5869C9.65413 28.8421 9.61848 29.1142 9.48648 29.3431C9.35449 29.5721 9.13696 29.7392 8.88175 29.8078C8.62654 29.8763 8.35456 29.8406 8.12564 29.7086L4.47609 27.6016ZM1.02704 42.4766C0.893472 42.4802 0.760544 42.4569 0.636102 42.4083C0.51166 42.3596 0.398226 42.2865 0.302495 42.1933C0.206763 42.1001 0.130675 41.9886 0.078721 41.8655C0.026767 41.7424 0 41.6101 0 41.4764C0 41.3428 0.026767 41.2105 0.078721 41.0874C0.130675 40.9643 0.206763 40.8528 0.302495 40.7596C0.398226 40.6664 0.51166 40.5933 0.636102 40.5446C0.760544 40.4959 0.893472 40.4727 1.02704 40.4763H5.24112C5.50172 40.4832 5.74932 40.5916 5.93119 40.7785C6.11306 40.9653 6.21483 41.2157 6.21483 41.4764C6.21483 41.7372 6.11306 41.9876 5.93119 42.1744C5.74932 42.3612 5.50172 42.4697 5.24112 42.4766H1.02704ZM5.47148 57.08C5.24256 57.212 4.97058 57.2477 4.71537 57.1791C4.46016 57.1106 4.24263 56.9435 4.11063 56.7145C3.97864 56.4855 3.94298 56.2135 4.01152 55.9583C4.08006 55.703 4.24716 55.4854 4.47609 55.3534L8.12564 53.2464C8.23899 53.181 8.3641 53.1386 8.49383 53.1216C8.62357 53.1046 8.75538 53.1133 8.88175 53.1473C9.00811 53.1812 9.12656 53.2397 9.23032 53.3194C9.33408 53.3992 9.42112 53.4985 9.48648 53.6119C9.55184 53.7253 9.59423 53.8504 9.61124 53.9802C9.62825 54.1099 9.61953 54.2418 9.5856 54.3681C9.55166 54.4945 9.49317 54.613 9.41346 54.7168C9.33375 54.8206 9.23438 54.9076 9.12103 54.973L5.47148 57.08ZM56.5211 55.3534C56.6344 55.4188 56.7338 55.5059 56.8135 55.6096C56.8932 55.7134 56.9517 55.8319 56.9856 55.9583C57.0196 56.0846 57.0283 56.2165 57.0113 56.3462C56.9943 56.476 56.9519 56.6011 56.8865 56.7145C56.8212 56.8279 56.7341 56.9272 56.6304 57.007C56.5266 57.0867 56.4082 57.1452 56.2818 57.1791C56.1554 57.2131 56.0236 57.2218 55.8939 57.2048C55.7641 57.1878 55.639 57.1454 55.5257 57.08L51.8761 54.973C51.6472 54.841 51.4801 54.6234 51.4116 54.3681C51.343 54.1129 51.3787 53.8409 51.5107 53.6119C51.6427 53.3829 51.8602 53.2158 52.1154 53.1473C52.3706 53.0787 52.6426 53.1144 52.8715 53.2464L56.5211 55.3513V55.3534ZM59.973 40.4784C60.1065 40.4748 60.2395 40.4981 60.3639 40.5467C60.4883 40.5954 60.6018 40.6685 60.6975 40.7617C60.7932 40.855 60.8693 40.9664 60.9213 41.0895C60.9732 41.2127 61 41.3449 61 41.4786C61 41.6122 60.9732 41.7445 60.9213 41.8676C60.8693 41.9907 60.7932 42.1022 60.6975 42.1954C60.6018 42.2887 60.4883 42.3618 60.3639 42.4104C60.2395 42.4591 60.1065 42.4823 59.973 42.4788H55.756C55.4954 42.4718 55.2478 42.3634 55.066 42.1766C54.8841 41.9898 54.7823 41.7393 54.7823 41.4786C54.7823 41.2178 54.8841 40.9674 55.066 40.7806C55.2478 40.5938 55.4954 40.4853 55.756 40.4784H59.973ZM55.5257 25.875C55.7546 25.743 56.0266 25.7073 56.2818 25.7759C56.537 25.8444 56.7545 26.0116 56.8865 26.2405C57.0185 26.4695 57.0542 26.7415 56.9856 26.9968C56.9171 27.252 56.75 27.4696 56.5211 27.6016L52.8715 29.7086C52.7582 29.774 52.6331 29.8164 52.5033 29.8334C52.3736 29.8504 52.2418 29.8417 52.1154 29.8078C51.989 29.7738 51.8706 29.7153 51.7668 29.6356C51.6631 29.5559 51.576 29.4565 51.5107 29.3431C51.4453 29.2297 51.4029 29.1046 51.3859 28.9749C51.3689 28.8451 51.3776 28.7133 51.4116 28.5869C51.4455 28.4605 51.504 28.342 51.5837 28.2383C51.6634 28.1345 51.7628 28.0474 51.8761 27.982L55.5257 25.875ZM44.3716 15.453C44.5031 15.224 44.7202 15.0567 44.975 14.9878C45.2299 14.9189 45.5017 14.9541 45.7306 15.0857C45.9595 15.2172 46.1268 15.4343 46.1957 15.6893C46.2646 15.9442 46.2294 16.216 46.0979 16.445L43.9905 20.0951C43.9286 20.2141 43.8433 20.3193 43.7397 20.4045C43.6362 20.4897 43.5165 20.5531 43.3878 20.5909C43.2592 20.6287 43.1242 20.6401 42.991 20.6244C42.8579 20.6087 42.7292 20.5663 42.6128 20.4997C42.4965 20.433 42.3948 20.3436 42.3138 20.2367C42.2329 20.1297 42.1744 20.0076 42.1418 19.8775C42.1092 19.7474 42.1033 19.612 42.1243 19.4796C42.1453 19.3471 42.1929 19.2203 42.2642 19.1067L44.3716 15.453Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Setup & Smooth Sail",
      subHeading:
        "Simplifying the process of setting up and maintaining medical infrastructure and operations for a hassle-free experience.",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <g clip-path="url(#clip0_336_130)">
            <circle cx="39" cy="61.1548" r="29" fill="#EDD696" />
            <path
              d="M40.2845 38.1221C40.4846 37.9219 40.6348 37.7218 40.8349 37.5216L42.5364 38.6225L41.4355 40.324L51.6943 46.0289C52.445 46.5294 53.3457 46.6795 54.1965 46.4793C55.0472 46.2791 55.7978 45.7787 56.2983 45.0281C56.7987 44.2774 56.9488 43.3766 56.7487 42.5259C56.5485 41.6752 56.0481 40.9245 55.2974 40.4241L45.6891 33.7684L44.7383 35.2697L42.9868 34.1687C43.0869 34.0186 43.1369 33.8184 43.237 33.6683C44.5381 30.6156 44.7884 27.3128 44.1378 24.2101C43.2871 20.3068 40.935 16.7537 37.382 14.4517C33.8789 12.1998 29.7254 11.4992 25.6719 12.3499C21.6184 13.2507 18.1654 15.6527 15.9135 19.1558C11.3095 26.362 13.4113 35.9703 20.6175 40.5742C24.1205 42.8262 28.2741 43.5268 32.3276 42.676C35.3802 42.0255 38.1827 40.4241 40.2845 38.1221ZM23.1697 36.6208C18.1654 33.4181 16.7141 26.7623 19.9169 21.758C21.5183 19.2559 23.9704 17.6545 26.6727 17.054C29.3751 16.4534 32.2776 16.9038 34.7797 18.5052C37.2819 20.1066 38.8833 22.5587 39.4838 25.261C40.0843 27.9634 39.6339 30.8659 38.0325 33.368C34.8298 38.3223 28.174 39.7735 23.1697 36.6208Z"
              fill="#111827"
            />
            <path
              d="M56.899 59.9409C56.5987 58.0893 55.3977 56.4879 53.6962 55.6372C48.0914 52.8347 35.8808 48.7312 35.8808 48.7312H34.8299L31.4771 53.185L34.6298 74.9038H57.9999C57.9999 74.9038 57.8498 65.4957 56.899 59.9409Z"
              fill="#111827"
            />
            <path
              d="M22.1191 48.7312C22.1191 48.7312 9.8585 52.8347 4.30371 55.6372C2.60224 56.4879 1.40121 58.0893 1.10095 59.9409C0.15013 65.5457 0 74.9538 0 74.9538H23.4202L26.4728 53.185L23.1199 48.7312H22.1191Z"
              fill="#111827"
            />
          </g>
          <defs>
            <clipPath id="clip0_336_130">
              <rect width="90" height="90" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      mainHeading: "Theater of Excellence",
      subHeading:
        "Bringing expertise to the forefront in setting up and maintaining OTs, transplant units, and ICUs.",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="39" cy="61" r="29" fill="#EDD696" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.7732 62.4133H18.278V65.2642H42.7732V62.4133ZM40.9844 67.2638H20.0668V69.7868H40.9844V67.266V67.2638ZM24.48 71.7865V72.2501C24.4822 72.9785 24.7724 73.6764 25.2873 74.1916C25.8021 74.7068 26.4997 74.9974 27.228 75H33.8239C34.5517 74.9972 35.2488 74.7068 35.7634 74.1921C36.278 73.6774 36.5684 72.9801 36.5712 72.2523V71.7886L24.48 71.7865ZM33.4442 44.0987H35.5204C35.9312 44.0988 36.3328 43.9771 36.6744 43.7489C37.0161 43.5207 37.2824 43.1963 37.4397 42.8167C37.5969 42.4372 37.6381 42.0194 37.558 41.6165C37.4779 41.2135 37.2801 40.8433 36.9896 40.5527C36.6991 40.2622 36.329 40.0644 35.9261 39.9842C35.5231 39.9041 35.1055 39.9453 34.726 40.1026C34.3465 40.2599 34.0221 40.5263 33.794 40.868C33.5658 41.2096 33.4441 41.6113 33.4442 42.0222V44.0987ZM27.5529 44.0987V42.0222C27.5529 41.6115 27.4312 41.2101 27.203 40.8686C26.9749 40.5271 26.6507 40.261 26.2713 40.1038C25.8919 39.9467 25.4745 39.9056 25.0718 39.9857C24.6691 40.0658 24.2991 40.2636 24.0088 40.554C23.7184 40.8444 23.5207 41.2143 23.4406 41.6171C23.3605 42.0199 23.4016 42.4374 23.5587 42.8168C23.7159 43.1963 23.982 43.5206 24.3234 43.7487C24.6648 43.9769 25.0662 44.0987 25.4768 44.0987H27.5529ZM31.4442 60.4158V46.0983H29.553V60.4158H31.4442ZM27.5529 60.4158H20.2759C20.2013 60.3071 20.137 60.1916 20.0839 60.0709C19.9781 59.8332 19.9178 59.5778 19.9061 59.3179C19.8661 58.2621 19.6301 57.2231 19.2101 56.2537C18.7786 55.2812 18.1731 54.3958 17.4233 53.6411C14.8997 51.0658 13.1925 47.8026 12.5158 44.2608C11.8391 40.7189 12.223 37.0561 13.6194 33.7316C15.0159 30.4072 17.3626 27.5691 20.3654 25.5733C23.3681 23.5774 26.8932 22.5128 30.4986 22.5128C34.1039 22.5128 37.629 23.5774 40.6318 25.5733C43.6346 27.5691 45.9813 30.4072 47.3777 33.7316C48.7741 37.0561 49.1581 40.7189 48.4814 44.2608C47.8047 47.8026 46.0974 51.0658 43.5738 53.6411C42.8241 54.3958 42.2186 55.2812 41.7871 56.2537C41.3671 57.2231 41.131 58.2621 41.091 59.3179C41.0722 59.7112 40.9439 60.0915 40.7206 60.4158H33.4442V46.0983H35.5204C36.3264 46.0982 37.1142 45.859 37.7843 45.411C38.4545 44.9631 38.9767 44.3264 39.2851 43.5816C39.5934 42.8368 39.674 42.0172 39.5167 41.2266C39.3593 40.4359 38.9711 39.7097 38.4012 39.1397C37.8312 38.5698 37.105 38.1816 36.3145 38.0244C35.5239 37.8672 34.7045 37.9479 33.9599 38.2565C33.2152 38.565 32.5788 39.0874 32.131 39.7577C31.6832 40.428 31.4442 41.2161 31.4442 42.0222V44.0987H29.553V42.0222C29.5531 41.2159 29.3141 40.4276 28.8663 39.7571C28.4185 39.0866 27.782 38.5639 27.0372 38.2552C26.2924 37.9466 25.4728 37.8657 24.682 38.023C23.8913 38.1802 23.1649 38.5684 22.5948 39.1385C22.0247 39.7087 21.6364 40.4351 21.479 41.2259C21.3217 42.0167 21.4024 42.8365 21.7109 43.5815C22.0194 44.3265 22.5418 44.9632 23.2121 45.4112C23.8825 45.8592 24.6706 46.0983 25.4768 46.0983H27.5529V60.4158ZM29.4989 11.9998C29.4989 11.7347 29.6042 11.4803 29.7917 11.2928C29.9792 11.1053 30.2335 11 30.4986 11C30.7637 11 31.018 11.1053 31.2054 11.2928C31.3929 11.4803 31.4982 11.7347 31.4982 11.9998V16.2146C31.4982 16.4797 31.3929 16.7341 31.2054 16.9216C31.018 17.1091 30.7637 17.2144 30.4986 17.2144C30.2335 17.2144 29.9792 17.1091 29.7917 16.9216C29.6042 16.7341 29.4989 16.4797 29.4989 16.2146V11.9998ZM14.8993 16.445C14.7678 16.216 14.7326 15.9442 14.8014 15.6893C14.8703 15.4343 15.0376 15.2172 15.2665 15.0857C15.4955 14.9541 15.7673 14.9189 16.0221 14.9878C16.277 15.0567 16.4941 15.224 16.6256 15.453L18.733 19.1067C18.7981 19.22 18.8403 19.3451 18.8571 19.4748C18.8739 19.6045 18.865 19.7362 18.8309 19.8624C18.7968 19.9886 18.7381 20.1069 18.6583 20.2104C18.5785 20.314 18.4791 20.4008 18.3658 20.466C18.2524 20.5311 18.1274 20.5733 17.9977 20.5901C17.8681 20.6068 17.7364 20.5979 17.6102 20.5638C17.484 20.5297 17.3657 20.4711 17.2622 20.3913C17.1586 20.3115 17.0718 20.212 17.0067 20.0987L14.8993 16.445ZM4.47609 27.6016C4.24716 27.4696 4.08006 27.252 4.01152 26.9968C3.94298 26.7415 3.97864 26.4695 4.11063 26.2405C4.24263 26.0116 4.46016 25.8444 4.71537 25.7759C4.97058 25.7073 5.24256 25.743 5.47148 25.875L9.12103 27.982C9.34995 28.1141 9.51706 28.3316 9.5856 28.5869C9.65413 28.8421 9.61848 29.1142 9.48648 29.3431C9.35449 29.5721 9.13696 29.7392 8.88175 29.8078C8.62654 29.8763 8.35456 29.8406 8.12564 29.7086L4.47609 27.6016ZM1.02704 42.4766C0.893472 42.4802 0.760544 42.4569 0.636102 42.4083C0.51166 42.3596 0.398226 42.2865 0.302495 42.1933C0.206763 42.1001 0.130675 41.9886 0.078721 41.8655C0.026767 41.7424 0 41.6101 0 41.4764C0 41.3428 0.026767 41.2105 0.078721 41.0874C0.130675 40.9643 0.206763 40.8528 0.302495 40.7596C0.398226 40.6664 0.51166 40.5933 0.636102 40.5446C0.760544 40.4959 0.893472 40.4727 1.02704 40.4763H5.24112C5.50172 40.4832 5.74932 40.5916 5.93119 40.7785C6.11306 40.9653 6.21483 41.2157 6.21483 41.4764C6.21483 41.7372 6.11306 41.9876 5.93119 42.1744C5.74932 42.3612 5.50172 42.4697 5.24112 42.4766H1.02704ZM5.47148 57.08C5.24256 57.212 4.97058 57.2477 4.71537 57.1791C4.46016 57.1106 4.24263 56.9435 4.11063 56.7145C3.97864 56.4855 3.94298 56.2135 4.01152 55.9583C4.08006 55.703 4.24716 55.4854 4.47609 55.3534L8.12564 53.2464C8.23899 53.181 8.3641 53.1386 8.49383 53.1216C8.62357 53.1046 8.75538 53.1133 8.88175 53.1473C9.00811 53.1812 9.12656 53.2397 9.23032 53.3194C9.33408 53.3992 9.42112 53.4985 9.48648 53.6119C9.55184 53.7253 9.59423 53.8504 9.61124 53.9802C9.62825 54.1099 9.61953 54.2418 9.5856 54.3681C9.55166 54.4945 9.49317 54.613 9.41346 54.7168C9.33375 54.8206 9.23438 54.9076 9.12103 54.973L5.47148 57.08ZM56.5211 55.3534C56.6344 55.4188 56.7338 55.5059 56.8135 55.6096C56.8932 55.7134 56.9517 55.8319 56.9856 55.9583C57.0196 56.0846 57.0283 56.2165 57.0113 56.3462C56.9943 56.476 56.9519 56.6011 56.8865 56.7145C56.8212 56.8279 56.7341 56.9272 56.6304 57.007C56.5266 57.0867 56.4082 57.1452 56.2818 57.1791C56.1554 57.2131 56.0236 57.2218 55.8939 57.2048C55.7641 57.1878 55.639 57.1454 55.5257 57.08L51.8761 54.973C51.6472 54.841 51.4801 54.6234 51.4116 54.3681C51.343 54.1129 51.3787 53.8409 51.5107 53.6119C51.6427 53.3829 51.8602 53.2158 52.1154 53.1473C52.3706 53.0787 52.6426 53.1144 52.8715 53.2464L56.5211 55.3513V55.3534ZM59.973 40.4784C60.1065 40.4748 60.2395 40.4981 60.3639 40.5467C60.4883 40.5954 60.6018 40.6685 60.6975 40.7617C60.7932 40.855 60.8693 40.9664 60.9213 41.0895C60.9732 41.2127 61 41.3449 61 41.4786C61 41.6122 60.9732 41.7445 60.9213 41.8676C60.8693 41.9907 60.7932 42.1022 60.6975 42.1954C60.6018 42.2887 60.4883 42.3618 60.3639 42.4104C60.2395 42.4591 60.1065 42.4823 59.973 42.4788H55.756C55.4954 42.4718 55.2478 42.3634 55.066 42.1766C54.8841 41.9898 54.7823 41.7393 54.7823 41.4786C54.7823 41.2178 54.8841 40.9674 55.066 40.7806C55.2478 40.5938 55.4954 40.4853 55.756 40.4784H59.973ZM55.5257 25.875C55.7546 25.743 56.0266 25.7073 56.2818 25.7759C56.537 25.8444 56.7545 26.0116 56.8865 26.2405C57.0185 26.4695 57.0542 26.7415 56.9856 26.9968C56.9171 27.252 56.75 27.4696 56.5211 27.6016L52.8715 29.7086C52.7582 29.774 52.6331 29.8164 52.5033 29.8334C52.3736 29.8504 52.2418 29.8417 52.1154 29.8078C51.989 29.7738 51.8706 29.7153 51.7668 29.6356C51.6631 29.5559 51.576 29.4565 51.5107 29.3431C51.4453 29.2297 51.4029 29.1046 51.3859 28.9749C51.3689 28.8451 51.3776 28.7133 51.4116 28.5869C51.4455 28.4605 51.504 28.342 51.5837 28.2383C51.6634 28.1345 51.7628 28.0474 51.8761 27.982L55.5257 25.875ZM44.3716 15.453C44.5031 15.224 44.7202 15.0567 44.975 14.9878C45.2299 14.9189 45.5017 14.9541 45.7306 15.0857C45.9595 15.2172 46.1268 15.4343 46.1957 15.6893C46.2646 15.9442 46.2294 16.216 46.0979 16.445L43.9905 20.0951C43.9286 20.2141 43.8433 20.3193 43.7397 20.4045C43.6362 20.4897 43.5165 20.5531 43.3878 20.5909C43.2592 20.6287 43.1242 20.6401 42.991 20.6244C42.8579 20.6087 42.7292 20.5663 42.6128 20.4997C42.4965 20.433 42.3948 20.3436 42.3138 20.2367C42.2329 20.1297 42.1744 20.0076 42.1418 19.8775C42.1092 19.7474 42.1033 19.612 42.1243 19.4796C42.1453 19.3471 42.1929 19.2203 42.2642 19.1067L44.3716 15.453Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Accreditation Made Easy",
      subHeading:
        "Guiding through the accreditation journey with NABH/NABL accreditation services for seamless compliance.",
    },

    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          viewBox="0 0 90 90"
          fill="none"
        >
          <circle cx="42" cy="61" r="29" fill="#EDD696" />
          <path
            d="M51.32 26.6212L55.7 27.6912C55.78 27.7112 55.85 27.7212 55.93 27.7212C56.19 27.7212 56.44 27.6112 56.63 27.4212L63.74 19.7212C64 19.4512 64.07 19.0512 63.92 18.7012C63.78 18.3612 63.44 18.1312 63.07 18.1212L57.16 17.9412L56.88 11.9012C56.86 11.5412 56.63 11.2012 56.29 11.0712C55.95 10.9312 55.55 11.0012 55.28 11.2512L47.6 18.3712C47.34 18.6112 47.24 18.9612 47.31 19.2912L48.38 23.6712C48.34 23.7012 48.3 23.7312 48.26 23.7612L47.12 24.9012C42.12 20.5812 35.62 17.9612 28.51 17.9612C12.79 17.9712 0 30.7612 0 46.4912C0 62.2212 12.79 75.0012 28.51 75.0012C44.23 75.0012 57.02 62.2112 57.02 46.4912C57.02 39.3812 54.4 32.8812 50.08 27.8812L51.22 26.7412C51.26 26.7012 51.29 26.6612 51.32 26.6212ZM28.51 70.8112C15.1 70.8112 4.19 59.9012 4.19 46.4912C4.19 33.0812 15.1 22.1612 28.51 22.1612C34.46 22.1612 39.92 24.3112 44.15 27.8812L41.54 30.4912C37.98 27.5912 33.45 25.8412 28.51 25.8412C17.13 25.8412 7.87 35.1012 7.87 46.4812C7.87 57.8612 17.13 67.1212 28.51 67.1212C39.89 67.1212 49.15 57.8612 49.15 46.4812C49.15 41.5412 47.41 37.0012 44.5 33.4512L47.11 30.8412C50.67 35.0712 52.83 40.5312 52.83 46.4812C52.84 59.9012 41.93 70.8112 28.51 70.8112ZM27.03 45.0012C26.63 45.4012 26.42 45.9212 26.42 46.4812C26.42 47.0412 26.64 47.5712 27.03 47.9612C27.43 48.3612 27.95 48.5712 28.51 48.5712C29.07 48.5712 29.6 48.3512 29.99 47.9612L35.47 42.4812C36.15 43.6612 36.54 45.0212 36.54 46.4812C36.54 50.9112 32.94 54.5112 28.51 54.5112C24.08 54.5112 20.48 50.9112 20.48 46.4812C20.48 42.0512 24.08 38.4512 28.51 38.4512C29.96 38.4512 31.33 38.8412 32.51 39.5212L27.03 45.0012ZM35.54 36.5012C33.55 35.1012 31.13 34.2612 28.52 34.2612C21.78 34.2612 16.3 39.7412 16.3 46.4812C16.3 53.2212 21.78 58.7012 28.52 58.7012C35.26 58.7012 40.74 53.2212 40.74 46.4812C40.74 43.8712 39.91 41.4512 38.5 39.4612L41.52 36.4412C43.67 39.2212 44.97 42.7012 44.97 46.4812C44.97 55.5512 37.59 62.9312 28.52 62.9312C19.45 62.9312 12.07 55.5512 12.07 46.4812C12.07 37.4112 19.45 30.0312 28.52 30.0312C32.3 30.0312 35.78 31.3312 38.56 33.4812L35.54 36.5012Z"
            fill="#111827"
          />
        </svg>
      ),
      mainHeading: "Safety & Compliance Partner",
      subHeading:
        "Comprehensive services for gas pipeline setup, fire and safety, sewage treatment plant, and ensuring a safe and compliant medical space.",
    },

    // Add more card data as needed
  ];

  const accordionItems = [
    {
      image: facility,
      title: "Facility & Infrastructure",
      content: [
        { image: gas, title: "Gas Cylinder Supply", link: "#" },
        { image: radiation, title: "Radiation Dosimeter", link: "#" },
        { image: isa, title: "Industry Specific Architecture", link: "#" },
        { image: transplant, title: "Transplant Unit Setup", link: "#" },
        { image: leaddoor, title: "Lead Doors", link: "#" },
        { image: gaspipeline, title: "Gas Pipeline", link: "#" }, 
        { image: firegas, title: "Fire and Safety", link: "#" }, 
        { image: insurance, title: "Insurance Empanelment", link: "#" },   
        { image: accredition, title: "Accredition", link: "#" },


        { image: n1, title: "Sewage Treatment Plant", link: "#" },
        { image: n2, title: "Pharmacy Setup", link: "#" },  
        { image: n3, title: "Central Air Conditioning", link: "#" },   
        { image: n4, title: "Healthcare Standard Electrification", link: "#" },
        { image: n5, title: "Vinyl Flooring", link: "#" },


      ],
    },
    {
      image: furniture,
      title: "Furniture & Machinery",
      content: [
        { image: twoseven, title: "Medical Device ", link: "#" },
        { image: twosix, title: "Equipment Rental", link: "#" },
        { image: twofour, title: "Interior Design", link: "#" },
        { image: twothree, title: "Healthcare Furniture", link: "#" },
        { image: twotwo, title: "Healthcare Machinery", link: "#" },
        // { image: twofive, title: "Medical Device Traders", link: "#" }, 
        { image: twoone, title: "Biomedical Engineer", link: "#" },
      ],
    },
    {
      image: hospitality,
      title: "Hospitality",
      content: [
        {
          image: z1,
          title: "Housekeeping and Disinfectant Material",
          link: "#",
        },
        { image: z2, title: "Pest Control and Deep Cleaning", link: "#" },
        { image: z3, title: "Floor Mating", link: "#" },
        { image: z4, title: "Third Party Laundry", link: "#" },
        {
          image: z5,
          title: "Industry Specific Linen/Dresses",
          link: "#",
        },
      ],
    },
    {
      image: branding,
      title: "Branding & Promotions",
      content: [
        { image: fourone, title: "Signage Boards", link: "#" },
        { image: y1, title: "Internal Space Branding", link: "#" },
        { image: y2, title: "External Branding", link: "#" },
        { image: y3, title: "Digital Branding", link: "#" },
      ],
    },


    {
      image: eight,
      title: "IT, Hardware & Networking",
      content: [
        { image: eightthree, title: "Network Solutions", link: "#" },  
        { image: eighttwo, title: "Software Solutions", link: "#" },
        { image: eightone, title: "Hardware Supply", link: "#" },
      ],
    },
    {
      image: surgical,
      title: "Surgical & Disposables",
      content: [
        { image: sixthree, title: "Surgical Material Supply", link: "#" },
        { image: sixtwo, title: "Critical Care Disposables", link: "#" },
        { image: sixone, title: "Lab Disposables and Reagents Supply", link: "#"},
       
      
      ],
    },
    {
      image: seven,
      title: "Other",
      content: [
        {
          image: o1,
          title: "Stationary",
          link: "#",
        },
        {
          image: o2,
          title: "Security",
          link: "#",
        },
        {
          image: o3,
          title: "Third Party Housekeeping",
          link: "#",
        },
        {
          image: o4,
          title: "Audit",
          link: "#",
        },
        {
          image: o5,
          title: "Curtains",
          link: "#",
        },
        {
          image: o6,
          title: "Biosafety Bins and Covers",
          link: "#",
        },
      ],
    },
    {
      image: surgical,
      title: "Liaison/Legal",
      content: [
        { image: sixthree, title: "PESO License", link: "#" },
      ],
    },

  ];
  const customTestimonialData = [

    {
      id: 1,
      name: "Dr. Manav",
      heading: "“",
      description: "Tera Connects delivered exceptional gas pipeline setup service for Vijaya Hospital. Their efficiency and attention to safety standards were commendable. Grateful for their expertise in ensuring a reliable and secure gas infrastructure for our medical facility. This is the best platform for all medical industry needs. Highly Recommended!!!",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Vijaya Hospital",
    },
    {
      id: 2,
      name: "Dr. Indrasen",
      heading: "“",
      description: "Ozone Hospitals is immensely grateful to Tera Connects for their seamless assistance in insurance empanelment. Their expertise and efficient handling of the process have significantly eased our administrative burden, allowing us to focus more on patient care. Thank you, Tera Connects, for your invaluable support in optimizing our medical operations.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Ozone hospitals",
    },
    {
      id: 3,
      name: " Dr. Varun",
      heading: "“",
      description: "I sincerely appreciate Tera Connects for their outstanding service in OT set up. Their meticulous planning and execution have equipped our operation theatres with state-of-the-art facilities, enhancing our ability to provide top-notch surgical care. Tera Connects' commitment to excellence is truly commendable, making them an invaluable partner in our medical journey.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Perumalla Hospital",
    },
    {
      id: 4,
      name: "Dr. Ramesh",
      heading: "“",
      description: "Our entire team is grateful for the seamless coordination, expertise, and dedication Tera Connects brought to every aspect of the setup process. Their commitment to ensuring a smooth and efficient hospital establishment has been invaluable. Thank you, Tera Connects, for being an integral part of Sri Kanthi Hospital's foundation and success.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Sri Kanthi Hospital Kothagudam",
    },
    {
      id: 5,
      name: "Ravinder",
      heading: "“",
      description: "Since joining Tera Connects, Apex Medical Systems has seen an increase in inquiries from hospitals across India. Their seamless platform connects us with the right clients, and their competitive quoting system ensures we win more deals.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "APEX MEDICAL SYSTEMS",
    },
    {
      id: 6,
      name: "Mohammad",
      heading: "“",
      description: "Joining hands with Tera Connects was pivotal for Odyssey Healthcare. Their seamless services and branding expertise contributed to our growth, ensuring a seamless healthcare experience.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Odyssey Healthcare Services",
    },
    {
      id: 7,
      name: "Surya Vardhan",
      heading: "“",
      description: "Tera Connects delivered beyond expectations. Their tailored solutions boosted our visibility, paving the way for fruitful partnerships within the medical sector.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "GSR Media",
    },
    {
      id: 8,
      name: "Sridhar",
      heading: "“",
      description: "Sunriseoaks Enterprises experienced an exceptional partnership with Tera Connects. Their expertise in expanding market reach, fostering client interactions, and streamlining quoting processes propelled our growth in the medical landscape.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Sunriseoaks Enterprises",
    },
    {
      id: 9,
      name: "Ranjit",
      heading: "“",
      description: "Working alongside Tera Connects was a turning point for Earth Water Conditioners. Their focus reaching targetting customers, fostering direct client relationships, and refining quoting mechanisms elevated our stature in medical circles.      ",
      rating: 5,
      imageSrc: logodefault,
      organisation: "Earth Water conditioners",
    },
    {
      id: 10,
      name: "Arun Kumar",
      heading: "“",
      description: "Tera Connects helped us bring a remarkable shift in our healthcare business. Their dedication to extensive market research became our catalyst, shaping direct client connections and refining quoting processes for unparalleled success.",
      rating: 5,
      imageSrc: logodefault,
      organisation: "SAP healthcare systems",
    },



  ];

  return (
    <div className="background-white">
      <Helmet>
        <title>Create And Maintain a Smooth Healthcare Operations </title>
        <meta name="keyword" content="healthcare operations management" />
        <meta
          name="description"
          content="The better your healthcare operations, the better will be your customer experience. Hire our skilled people to create the best infrastructure following all rules."
        />
      </Helmet>
      <div className=" service-pages-header operation">
        <div className="container service-pages-header-inner">
          <div className="hero-inner">
            <h3 className="font-white regular title-custom title-heading-banner montserrat ">
              <span className="font-sky-blue bolders">
              Excellence Unleashed

              </span>
              <br />
              Power Your Medical Infrastructure and Operational Services
            </h3>
            <h5 className="font-white regular title-custom montserrat">
            Precision in every detail. Crafting brilliance for your medical facility.
            </h5>

            <Link to="/contact-us">
              <a href="/contact-us/" className="common-btn-custom">
                Get Started
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="27"
                    viewBox="0 0 26 27"
                    fill="none"
                  >
                    <path
                      d="M8.99945 7.14938L16.8203 14.4116L8.99946 21.6738"
                      stroke="black"
                      stroke-width="2"
                    />
                  </svg>
                </span>
              </a>{" "}
            </Link>
          </div>
        </div>
      </div>

      <div className="container tabsteraconnects background-white">
        <h2 className="servicepages-headings montserrat font-medium lg:mb-20 mb-10">
        Navigating 
          <span className="font-extrabold"> Medical Infrastructure and Operations</span>
        </h2>
        <Tabs tabData={tabData} />
      </div>

      <div className="teraservicesolution tabsteraconnects">
        <div className="container ">
          <h2 className="servicepages-headings montserrat font-medium  mb-10 lg:mb-20">
            Our <span className="font-extrabold">Solutions</span>
          </h2>
          <CardList cardData={cardData} />
        </div>
      </div>

      <div className="container teraserviceforyou tabsteraconnects background-white">
        <h2 className="servicepages-headings montserrat font-medium mb-5 text-center">
          {" "}
          Service for <span className="font-extrabold">You</span>
        </h2>
        <h5 className="font-black regular title-custom montserrat lg:mb-20 mb-10 text-center">
        Serving vast range of services to medical industry PAN India.
        </h5>
        <div className="bigbutn-wrapper">
          <Link className="bigbuttons" to="/ops-maintenance/vendors-suppliers">
          
              <span className="svgicon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="95"
                  height="95"
                  viewBox="0 0 95 95"
                  fill="none"
                >
                  <circle cx="52.5" cy="47.5" r="39.5" fill="#F0F0F0" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.3014 22.2908C14.2109 21.9455 15.2202 21.9755 16.1075 22.3743L16.1111 22.378L21.5768 24.8393C22.4627 25.2396 23.1535 25.9752 23.4974 26.8845C23.5001 26.8916 23.5027 26.8987 23.5054 26.9058C24.4981 26.496 25.4928 26.0908 26.4894 25.6904C28.1544 25.0182 29.8323 24.3786 31.5223 23.7719C32.2669 23.5078 32.9602 23.2803 33.5398 23.1153C34.0387 22.9685 34.6769 22.8071 35.1978 22.8071C35.6747 22.8071 36.1772 22.9172 36.5918 23.0272C37.0393 23.1483 37.5308 23.3097 38.0297 23.4931C39.0348 23.8599 40.1683 24.3368 41.2174 24.799C42.3501 25.3052 43.4738 25.8312 44.5881 26.3766C46.6856 25.9405 48.9932 25.5904 51.0043 25.3272C52.854 25.0831 54.7079 24.8727 56.5653 24.6962L56.812 24.6708C57.0097 24.5487 57.2192 24.4454 57.4375 24.3625L63.0389 22.2386C63.4895 22.0676 63.9695 21.9871 64.4512 22.0017C64.933 22.0163 65.4071 22.1257 65.8466 22.3236C66.286 22.5215 66.6822 22.8041 67.0124 23.1552C67.3426 23.5063 67.6003 23.919 67.7709 24.3698L74.6122 42.4322C74.7833 42.8826 74.8639 43.3623 74.8496 43.8439C74.8353 44.3255 74.7262 44.7995 74.5286 45.2389C74.3311 45.6784 74.0489 46.0746 73.6981 46.4049C73.3474 46.7353 72.9351 46.9933 72.4846 47.1642L72.4883 47.1679L66.8832 49.2918C66.0259 49.6162 65.0802 49.6072 64.232 49.2705C63.1521 50.225 62.01 51.1071 60.8131 51.9109C59.7017 52.6482 58.3958 53.3965 57.0825 53.8367C56.559 54.0133 55.9729 54.162 55.3607 54.2233C55.3088 54.6233 55.1261 54.9976 54.8376 55.2857L47.171 62.9523C45.9256 64.1963 44.3486 65.0557 42.6282 65.4277C40.9077 65.7998 39.1165 65.6689 37.4685 65.0506L27.124 61.1732L27.0397 61.1329C26.4789 60.8228 25.9462 60.4644 25.4477 60.0618C24.8534 59.6032 24.1564 59.0346 23.4044 58.3927C21.7206 56.9533 20.0599 55.4871 18.423 53.9945C16.7059 52.4348 15.0003 50.8624 13.3065 49.2774C12.8922 49.4173 12.4558 49.4821 12.0179 49.4683C11.5364 49.4532 11.0625 49.3434 10.6235 49.1451L5.15778 46.6837C4.27188 46.2834 3.5811 45.5478 3.2372 44.6385C2.8933 43.7293 2.9244 42.7207 3.32366 41.8343L11.2581 24.2157C11.657 23.3285 12.392 22.6361 13.3014 22.2908ZM15.8014 46.5895C17.4845 48.1638 19.1789 49.7262 20.8844 51.2763C22.5718 52.806 24.3142 54.3576 25.7741 55.5975C26.5078 56.2174 27.157 56.7457 27.6816 57.1528C28.1658 57.5233 28.4703 57.7288 28.6207 57.8131V57.8168L38.756 61.6171C39.7451 61.9877 40.82 62.0658 41.8523 61.842C42.8846 61.6183 43.8306 61.1021 44.5775 60.3552L51.8687 53.0641C50.8391 52.0232 49.7915 51.0004 48.7263 49.9961C47.7615 49.09 46.7271 48.1473 45.7734 47.3476C44.9003 46.6176 44.1703 46.0674 43.6458 45.7483C43.6234 45.761 43.6013 45.7745 43.5798 45.7886L39.9152 48.1546C36.9916 50.3262 34.1304 50.616 31.647 49.8714C29.27 49.1524 27.4358 47.5457 26.262 46.2765C24.4572 44.3103 24.813 41.5371 26.35 39.7984C28.4657 37.3924 30.6923 35.0862 33.0226 32.8874C34.2929 31.6871 35.633 30.5627 37.0356 29.52C37.8101 28.9527 38.6067 28.4283 39.3976 28.0061C38.5353 27.6256 37.662 27.2705 36.7788 26.9412C36.4064 26.803 36.0282 26.6806 35.6454 26.5744C35.5021 26.5331 35.3563 26.5012 35.2088 26.479L35.1758 26.4864C35.1025 26.4974 34.908 26.5377 34.5449 26.6404C33.9377 26.8198 33.3359 27.0167 32.7401 27.231C31.3168 27.7336 29.5671 28.4122 27.854 29.0982C26.1397 29.7847 24.4315 30.4862 22.7294 31.2024L15.8014 46.5895ZM44.565 30.1355C43.6649 30.3389 42.8449 30.5561 42.1565 30.7855C41.3971 31.0386 40.392 31.6072 39.1962 32.4802C38.026 33.3349 36.7715 34.4097 35.5206 35.5726C33.2776 37.6911 31.1343 39.9128 29.0975 42.2304C28.5693 42.8283 28.6574 43.4629 28.9618 43.7931C29.9339 44.8495 31.2361 45.9207 32.7034 46.3609C34.057 46.768 35.7297 46.7093 37.7656 45.1833L37.8169 45.1467L41.5879 42.711C42.3509 42.2157 43.7668 41.6288 45.2121 42.4212C46.0815 42.898 47.1233 43.6977 48.1247 44.5414C49.1591 45.4034 50.2523 46.3975 51.2427 47.3293C51.8701 47.922 52.4912 48.5211 53.1062 49.1267L53.1064 49.1274C53.5931 49.6051 54.076 50.0867 54.5549 50.5722C54.8007 50.6126 55.2262 50.5942 55.9085 50.3632C56.7889 50.0697 57.7903 49.5195 58.7807 48.8592C59.8676 48.1258 60.9052 47.322 61.8868 46.453L55.3099 29.0945C55.2393 28.9086 55.1841 28.7177 55.1446 28.5237C53.9242 28.6538 52.7054 28.7988 51.4885 28.9587C49.3242 29.2452 46.9672 29.6138 44.9556 30.0491C44.953 30.05 44.9503 30.0509 44.9476 30.0518C44.8224 30.0936 44.6942 30.1214 44.565 30.1355ZM53.6467 52.1551C53.6464 52.155 53.646 52.155 53.6457 52.155L54.0891 51.7571L53.6467 52.1551ZM10.5536 44.3393C10.2256 44.3291 9.90284 44.2545 9.60369 44.1196C8.99953 43.8472 8.52833 43.3459 8.29375 42.7261C8.05917 42.1063 8.08041 41.4187 8.35282 40.8145C8.62522 40.2104 9.12647 39.7392 9.7463 39.5046C10.3661 39.27 11.0537 39.2912 11.6579 39.5637C11.9571 39.6985 12.2267 39.891 12.4515 40.1301C12.6762 40.3692 12.8517 40.6502 12.9678 40.9571C13.084 41.264 13.1386 41.5908 13.1284 41.9188C13.1183 42.2468 13.0437 42.5696 12.9088 42.8687C12.7739 43.1679 12.5814 43.4375 12.3423 43.6623C12.1032 43.8871 11.8222 44.0625 11.5153 44.1787C11.2084 44.2948 10.8816 44.3494 10.5536 44.3393ZM61.4257 49.9227L61.4256 49.9228L61.4968 49.7174L61.4257 49.9227ZM60.8842 27.7076C61.1232 27.4827 61.4042 27.307 61.711 27.1907C62.3307 26.9557 63.0184 26.9766 63.6228 27.2487C64.2271 27.5207 64.6986 28.0218 64.9336 28.6415C65.1685 29.2612 65.1477 29.9489 64.8756 30.5532C64.6035 31.1576 64.1025 31.6291 63.4828 31.864C63.1759 31.9804 62.8492 32.0351 62.5211 32.0252C62.1931 32.0152 61.8703 31.9408 61.571 31.806C61.2718 31.6713 61.002 31.479 60.7771 31.24C60.5522 31.001 60.3766 30.7201 60.2602 30.4132C60.1439 30.1064 60.0891 29.7796 60.0991 29.4516C60.109 29.1236 60.1835 28.8007 60.3182 28.5015C60.4529 28.2023 60.6453 27.9325 60.8842 27.7076ZM17.438 65.0039C16.9547 65.0472 16.5082 65.2803 16.1964 65.6521H16.1927C16.0378 65.837 15.9209 66.0506 15.8487 66.2807C15.7765 66.5108 15.7504 66.7529 15.7719 66.9931C15.7933 67.2333 15.862 67.467 15.9738 67.6806C16.0857 67.8943 16.2386 68.0838 16.4238 68.2383L19.9416 71.1728C21.2554 72.2702 22.8501 72.978 24.5453 73.2161L29.0829 73.8507C29.3248 73.8916 29.5725 73.8836 29.8113 73.8272C30.0501 73.7707 30.2751 73.6669 30.473 73.5219C30.671 73.3768 30.8378 73.1936 30.9637 72.9829C31.0895 72.7723 31.1718 72.5385 31.2057 72.2955C31.2396 72.0525 31.2243 71.8051 31.1609 71.5681C31.0975 71.3311 30.9871 71.1092 30.8364 70.9156C30.6856 70.7219 30.4976 70.5605 30.2833 70.4409C30.0691 70.3213 29.833 70.2459 29.5891 70.2191L25.0552 69.5808C24.0381 69.4382 23.0813 69.0138 22.293 68.3556L18.7751 65.4211C18.4022 65.1106 17.9213 64.9606 17.438 65.0039Z"
                    fill="#111827"
                  />
                </svg>
              </span>
              <span className="btn-title montserrat">
                {" "}
                For <b>Partners</b>{" "}
              </span>
              <span className="btn-arrow">
      
              </span>
           
          </Link>

          <Link className="bigbuttons" to="/hiring-careers/for-clients">
           
              <span className="svgicon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="95"
                  height="95"
                  viewBox="0 0 95 95"
                  fill="none"
                >
                  <circle cx="47.5" cy="47.5" r="36.5" />
                  <path d="M23.3693 32.1981C23.3693 30.5806 24.0209 29.0292 25.1808 27.8854C26.3406 26.7416 27.9137 26.0991 29.554 26.0991C31.1943 26.0991 32.7674 26.7416 33.9272 27.8854C35.0871 29.0292 35.7386 30.5806 35.7386 32.1981C35.7386 33.8157 35.0871 35.367 33.9272 36.5108C32.7674 37.6546 31.1943 38.2972 29.554 38.2972C27.9137 38.2972 26.3406 37.6546 25.1808 36.5108C24.0209 35.367 23.3693 33.8157 23.3693 32.1981ZM29.554 20C26.2734 20 23.1273 21.2852 20.8076 23.5727C18.4879 25.8603 17.1847 28.963 17.1847 32.1981C17.1847 35.4333 18.4879 38.5359 20.8076 40.8235C23.1273 43.1111 26.2734 44.3962 29.554 44.3962C32.8345 44.3962 35.9807 43.1111 38.3004 40.8235C40.6201 38.5359 41.9233 35.4333 41.9233 32.1981C41.9233 28.963 40.6201 25.8603 38.3004 23.5727C35.9807 21.2852 32.8345 20 29.554 20ZM54.2926 35.2477C54.2926 34.4389 54.6184 33.6632 55.1984 33.0913C55.7783 32.5194 56.5648 32.1981 57.385 32.1981C58.2051 32.1981 58.9917 32.5194 59.5716 33.0913C60.1515 33.6632 60.4773 34.4389 60.4773 35.2477C60.4773 36.0564 60.1515 36.8321 59.5716 37.404C58.9917 37.9759 58.2051 38.2972 57.385 38.2972C56.5648 38.2972 55.7783 37.9759 55.1984 37.404C54.6184 36.8321 54.2926 36.0564 54.2926 35.2477ZM57.385 26.0991C54.9246 26.0991 52.5649 27.0629 50.8251 28.7786C49.0854 30.4943 48.108 32.8213 48.108 35.2477C48.108 37.674 49.0854 40.001 50.8251 41.7167C52.5649 43.4324 54.9246 44.3962 57.385 44.3962C59.8454 44.3962 62.205 43.4324 63.9448 41.7167C65.6846 40.001 66.662 37.674 66.662 35.2477C66.662 32.8213 65.6846 30.4943 63.9448 28.7786C62.205 27.0629 59.8454 26.0991 57.385 26.0991ZM11 58.1191C11 53.9108 14.4634 50.4953 18.7308 50.4953H40.3771C44.6446 50.4953 48.108 53.9108 48.108 58.1191V58.4119C48.1032 58.6342 48.0867 58.8561 48.0585 59.0767C48.0041 59.6111 47.9111 60.1411 47.7802 60.6624C47.3655 62.3502 46.6197 63.9415 45.5846 65.3465C42.9623 68.9023 38.0765 71.842 29.554 71.842C21.0315 71.842 16.1456 68.9023 13.5233 65.3465C12.1673 63.5003 11.3154 61.3412 11.0495 59.0767C11.0246 58.8537 11.0081 58.6299 11 58.4058V58.1191ZM17.1847 58.2777C17.2103 58.5984 17.262 58.9166 17.3393 59.2292C17.5063 59.9184 17.8464 60.8393 18.5267 61.7603C19.7637 63.4436 22.6086 65.743 29.554 65.743C36.4932 65.743 39.3381 63.4436 40.5812 61.7603C41.3298 60.7375 41.7926 59.5386 41.9233 58.2838V58.1191C41.9233 57.7147 41.7604 57.3269 41.4705 57.041C41.1805 56.755 40.7872 56.5944 40.3771 56.5944H18.7308C18.3208 56.5944 17.9275 56.755 17.6375 57.041C17.3476 57.3269 17.1847 57.7147 17.1847 58.1191V58.2777ZM57.3788 68.7925C55.4378 68.8115 53.5013 68.6068 51.6085 68.1826C52.7393 66.4221 53.5415 64.4764 53.9772 62.4373C54.9358 62.5958 56.0614 62.6934 57.3788 62.6934C62.8831 62.6934 64.9736 61.0345 65.7899 60.0281C66.2438 59.471 66.5422 58.8066 66.6558 58.1008V58.0703C66.6429 57.6745 66.4744 57.2991 66.1858 57.0236C65.8972 56.7481 65.5112 56.5942 65.1096 56.5944H54.2061C53.9622 54.4118 53.1878 52.3196 51.9487 50.4953H65.1158C69.3832 50.4953 72.8466 53.9108 72.8466 58.1191V58.2228C72.8413 58.4125 72.8268 58.6017 72.8033 58.79C72.5578 60.6357 71.805 62.38 70.6263 63.834C68.3442 66.6395 64.2561 68.7925 57.385 68.7925H57.3788Z" />
                </svg>
              </span>
              <span className="btn-title montserrat">
                {" "}
                For <b>Clients</b>{" "}
              </span>
              <span className="btn-arrow">
         
              </span>
           
          </Link>
        </div>
      </div>

      <div className="container teraserviceforyou tabsteraconnects background-white">
        <h2 className="servicepages-headings montserrat font-medium mb-5">
          {" "}
          All <span className="font-extrabold">Services</span>
        </h2>
        <h5 className="font-black regular title-custom montserrat lg:mb-20 mb-10">
        Our extensive array of services for medical organizations across India.
        </h5>
        <Accordion items={accordionItems} />
      </div>

      <div className="container background-white">
        <div className="flex flex-col items-center justify-center terastafftocontact">
          <h2 className="font-sky-blue bolds title-custom montserrat text-center mb-5">
            Let’s Start Our Journey
          </h2>
          <h4 className="font-white regular title-custom montserrat text-center mb-5">
          Discover how we can meet your medical industry needs.
          </h4>
          <a href="#download-app-now" className="common-btn-custom blue-btn">
            Install App
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="45"
                viewBox="0 0 44 45"
                fill="none"
              >
                <rect width="44" height="45" rx="22" fill="none" />
                <path
                  d="M22.5 28.25L15.3125 21.0625L17.325 18.9781L21.0625 22.7156V11H23.9375V22.7156L27.675 18.9781L29.6875 21.0625L22.5 28.25ZM11 34V26.8125H13.875V31.125H31.125V26.8125H34V34H11Z"
                  fill="white"
                />
              </svg>
            </span>
          </a>
        </div>
      </div>
      <div className="container background-white">
        <div className="sec-padding">
          <h2 className="servicepages-headings montserrat font-medium lg:mb-10 mb-10">
            {" "}
           <span className="font-extrabold">Testimonials</span>
          </h2>
          <TestimonialSlider perView={1} testimonialData={customTestimonialData}/>
        </div>
      </div>


      <div className="appdownload-main no-mob-padding" id="download-app-now">
      <Tab
        tabData={[
          {
            tabName: "Tab1",
            buttonContent: "+ Client",
            content: (
              <div className="conent-tab-1">
             

                <div id="download-app-now">
                <JoinNetwork
                    heading="Join Our Network"
                    subheading="Unlock collaboration with Tera Client—connect with professionals and vendors for exceptional medical synergy across India."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.teraconnects"
                    appStoreUrl="https://apps.apple.com/in/app/tera-connects/id6448921572"
                    imageUrl={qrteraclients}
                  />
                </div>
               
              </div>
            ),
          },

          {
            tabName: "Tab3",
            buttonContent: "+ Partner",
            content: (
              <div className="conent-tab-1">
             

                <div id="download-app-now">
                <JoinNetwork
                    heading="Join Our Network"
                    subheading="Unlock growth with Tera Partner—connecting providers and medical establishments nationwide for 10X business success."
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.teraplatforms.terapartner"
                    appStoreUrl="https://apps.apple.com/in/app/tera-partner-healthcare/id6453868120"
                    imageUrl={qrterapartner}
                  />
                </div>
               
              </div>
            ),
          },

       
        ]}
      />
      </div>
    </div>
  );
}

export default staffinghr;
